<template>
  <div class="header-view flex-c-c">
    <!-- 顶部栏 -->
    <!-- <div class="flex-c-c top">
      <div class="logo">
        <a href="https://octopusworks.com" style="font-family: simsun;" >
          <img src="../assets/images/logo03.png" alt="" />
        </a>
      </div>
      <div class="right"> -->
        <!-- 语言 -->
        <!-- <el-dropdown @command="setLanguage" :tabindex="9999">
          <div class="flex-c mr30 el-dropdown-link">
            <svg
              style="margin-right: 5px"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <circle cx="9.99929" cy="10" r="6.77273" stroke="black" />
              <path
                d="M13.136 10C13.136 11.9475 12.7403 13.686 12.1237 14.919C11.4923 16.182 10.7124 16.7727 9.99964 16.7727C9.2869 16.7727 8.50704 16.182 7.87556 14.919C7.25904 13.686 6.86328 11.9475 6.86328 10C6.86328 8.05251 7.25904 6.31408 7.87556 5.08103C8.50704 3.81808 9.2869 3.22729 9.99964 3.22729C10.7124 3.22729 11.4923 3.81808 12.1237 5.08103C12.7403 6.31408 13.136 8.05251 13.136 10Z"
                stroke="black"
              />
              <path d="M16.362 6.81812H3.63477" stroke="black" />
              <path d="M16.362 12.7273H3.63477" stroke="black" />
            </svg>
            <div class="language-text" style="cursor:pointer;"> -->
             <!--  {{ lang == "cn" ? "简体中文" : "English"
              }} -->
                <!-- <span v-if="lang === 'cn'">简体中文</span>
                <span v-else-if="lang === 'en'">English</span>
                <span v-else>日本語</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="cn" class="language-text"
              >简体中文</el-dropdown-item
            >
            <el-dropdown-item command="en" class="language-text"
              >English</el-dropdown-item
            >
            <el-dropdown-item command="ja" class="language-text"
              >日本語</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M11.1604 3.42242C11.1604 2.63809 10.4958 2 9.67598 2C8.8562 2 8.19263 2.63699 8.19263 3.42242C8.19227 3.50261 8.19894 3.58268 8.21257 3.6617C6.16424 4.3419 4.4826 6.4434 4.4826 8.93152V10.889C4.4826 10.889 4.4826 13.7095 3.76031 13.7339C3.66374 13.7273 3.56685 13.7406 3.47556 13.7727C3.38427 13.8049 3.3005 13.8553 3.22935 13.921C3.15821 13.9866 3.10118 14.066 3.06176 14.1544C3.02234 14.2428 3.00134 14.3383 3.00006 14.4351C2.99878 14.5319 3.01724 14.6279 3.05431 14.7173C3.09137 14.8068 3.14628 14.8877 3.21566 14.9552C3.28504 15.0227 3.36745 15.0753 3.45786 15.1099C3.54826 15.1444 3.64477 15.1602 3.74148 15.1563H15.6116C15.7083 15.1617 15.8051 15.1473 15.8961 15.114C15.9871 15.0807 16.0703 15.0292 16.1407 14.9626C16.2111 14.896 16.2672 14.8158 16.3055 14.7268C16.3438 14.6378 16.3636 14.5419 16.3636 14.4451C16.3636 14.3482 16.3438 14.2523 16.3055 14.1633C16.2672 14.0743 16.2111 13.9941 16.1407 13.9275C16.0703 13.861 15.9871 13.8094 15.8961 13.7761C15.8051 13.7428 15.7083 13.7284 15.6116 13.7339C14.8694 13.7339 14.8694 10.909 14.8694 10.909V8.93152C14.8694 6.44118 13.2985 4.33746 11.1405 3.65506C11.1538 3.57822 11.1604 3.50039 11.1604 3.42242ZM11.9016 15.8664C11.9016 17.0451 10.9123 18 9.67598 18C8.43967 18 7.45262 17.0495 7.4504 15.8664H11.9016Z"
            fill="black"
          />
          <ellipse cx="13.4" cy="4.4" rx="2.4" ry="2.4" fill="#D71518" />
        </svg>
      </div>
    </div> -->
    <!-- 顶部栏 end -->

    <el-divider class="divider"></el-divider>

    <!-- 导航栏 -->
    <div class="flex-c-b nav">
      <!-- 左边导航栏 -->

      <div class="flex-c navBox">
        <img
          @click="toModel('/')"
          class="logo mr90 btn"
          src="../assets/images/head/octopusworks.svg"
          alt=""
          width="130"
          height="40"
        /> 
        <el-menu
          class="menuNav"
          :default-active="$route.path"
          active-text-color="red"
          router
          mode="horizontal"
          @select="selectMenu"
          ref="menu"
        >
          <el-menu-item
          ref="item"
            v-for="route in routes"
            :key="route.path"
            :index="route.path"
            :class="
              ($route.path == '/modelLib' && route.path == '/modelLib') ||
              (route.path != '/modelLib' &&
                ($route.path.indexOf(route.path) > -1 ||
                  route.field.indexOf($route.path) > -1))
                ? 'is-active'
                : ''
            "
            >{{ route.name }}</el-menu-item
          >
        </el-menu>
      </div>

      <div class="right">
        <!-- 右边搜索框 -->
        <div class="search-view-bg">
          <!-- <img class="search-logo mr10" src="../assets/images/search-logo.png" alt="" @click="handleSearch"/> -->
          <el-select
            v-model="searchSelect"
            :class="lang"
            :placeholder="$t('common.qxz')"
          >
            <!-- 模型库 -->
            <el-option :label="$t('header.modelBase')" :value="0"></el-option>
            <!-- 模型专栏 -->
            <el-option :label="$t('header.modelColumn')" :value="1"></el-option>
            <!-- 产品库 -->
            <el-option
              :label="$t('header.productLibrary')"
              :value="2"
            ></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <!-- 搜索你感兴趣的内容 -->
          <input
            class="input ml5"
            type="text"
            v-model="search"
            @keyup.enter="handleSearch('enterSearch')"
            :placeholder="$t('header.searchPlaceholder')"
          />
        </div>

        <div class="file-upload" @click="openUploadModel">
          <img src="../assets/images/head/file-upload.svg" alt="" />
          <span>{{ $t("header.fileUpload") }}</span>
        </div>
        <div class="workbenches" @click="toModel('/workbenches')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M3.2627 13.2543L3.15739 13.2543L3.15741 13.201L3.15745 12.9091L3.15745 11.8673L3.15722 8.70583L3.15691 5.54439L3.1568 4.50256L3.15677 4.21066L3.15676 4.15729L3.26214 4.15722L3.70119 4.15709L5.26831 4.15689L10.0237 4.15672L14.7791 4.15672L16.3462 4.15675L16.7853 4.15675L16.8906 4.15676L16.8906 4.21003L16.8905 4.50193L16.8905 5.54378L16.8908 8.70522L16.8911 11.8667L16.8912 12.9085L16.8912 13.2004L16.8912 13.2538L16.7858 13.2538L16.3468 13.254L14.7797 13.2542L10.0243 13.2543L5.26888 13.2543L3.70176 13.2543L3.2627 13.2543ZM16.8912 13.3037C16.8912 13.3036 16.8912 13.3036 16.8913 13.3036C16.8915 13.3036 16.8944 13.3037 16.923 13.3037H16.8912ZM3.15672 4.10746C3.15643 4.10741 3.15354 4.10739 3.1251 4.10738H3.15676C3.15675 4.10741 3.15674 4.10744 3.15672 4.10746ZM15.1761 17.0489C15.1761 17.046 15.1761 17.0358 15.1761 17V17.05C15.5094 17.05 15.7795 16.7799 15.7795 16.4466V16.4209C15.7795 16.0876 15.5094 15.8175 15.1761 15.8175H10.6145V14.461H16.9406C17.5808 14.461 18.098 13.9431 18.098 13.3037V4.10738C18.098 3.46949 17.5796 2.95 16.9406 2.95H3.10734C2.46719 2.95 1.95 3.46799 1.95 4.10738V13.3037C1.95 13.9416 2.46841 14.461 3.10734 14.461H9.43261L9.40883 15.8175H4.87184C4.53861 15.8175 4.26847 16.0876 4.26847 16.4209V16.4466C4.26847 16.7799 4.53861 17.05 4.87184 17.05H4.87375H4.87587H4.87821H4.88077H4.88355H4.88655H4.88976H4.89319H4.89684H4.9007H4.90477H4.90905H4.91355H4.91825H4.92317H4.92829H4.93362H4.93916H4.94491H4.95086H4.95701H4.96337H4.96993H4.97669H4.98365H4.99081H4.99817H5.00573H5.01349H5.02144H5.02959H5.03793H5.04647H5.0552H5.06412H5.07323H5.08253H5.09202H5.1017H5.11157H5.12162H5.13186H5.14229H5.1529H5.16369H5.17466H5.18582H5.19715H5.20867H5.22036H5.23223H5.24428H5.25651H5.26891H5.28148H5.29423H5.30715H5.32024H5.33351H5.34694H5.36054H5.37431H5.38825H5.40235H5.41662H5.43106H5.44565H5.46042H5.47534H5.49042H5.50567H5.52107H5.53663H5.55235H5.56823H5.58426H5.60045H5.61679H5.63328H5.64993H5.66672H5.68367H5.70077H5.71802H5.73541H5.75295H5.77064H5.78848H5.80645H5.82457H5.84284H5.86124H5.87979H5.89848H5.9173H5.93627H5.95537H5.97461H5.99398H6.01349H6.03313H6.0529H6.07281H6.09285H6.11302H6.13331H6.15374H6.17429H6.19497H6.21578H6.23671H6.25777H6.27895H6.30025H6.32167H6.34321H6.36488H6.38666H6.40856H6.43058H6.45271H6.47496H6.49732H6.5198H6.54239H6.56509H6.5879H6.61082H6.63386H6.657H6.68024H6.7036H6.72706H6.75062H6.77429H6.79806H6.82193H6.84591H6.86998H6.89416H6.91843H6.9428H6.96727H6.99183H7.01649H7.04124H7.06609H7.09103H7.11606H7.14118H7.16639H7.19169H7.21708H7.24255H7.26811H7.29376H7.31949H7.3453H7.3712H7.39718H7.42324H7.44938H7.4756H7.5019H7.52828H7.55473H7.58126H7.60786H7.63454H7.66129H7.68811H7.715H7.74197H7.769H7.7961H7.82327H7.85051H7.87781H7.90518H7.93261H7.96011H7.98766H8.01529H8.04297H8.07071H8.09851H8.12636H8.15428H8.18225H8.21028H8.23836H8.26649H8.29468H8.32292H8.35121H8.37955H8.40794H8.43638H8.46487H8.4934H8.52198H8.5506H8.57927H8.60798H8.63674H8.66553H8.69437H8.72324H8.75216H8.78111H8.8101H8.83912H8.86818H8.89727H8.9264H8.95556H8.98476H9.01398H9.04323H9.07251H9.10182H9.13116H9.16052H9.18991H9.21933H9.24877H9.27823H9.30771H9.33721H9.36674H9.39628H9.42584H9.45542H9.48502H9.51463H9.54426H9.5739H9.60356H9.63322H9.6629H9.69259H9.72229H9.752H9.78171H9.81143H9.84116H9.8709H9.90064H9.93038H9.96012H9.98987H10.0196H10.0494H10.0791H10.1089H10.1386H10.1683H10.1981H10.2278H10.2575H10.2872H10.3169H10.3466H10.3763H10.406H10.4357H10.4653H10.495H10.5246H10.5542H10.5838H10.6134H10.643H10.6725H10.702H10.7315H10.761H10.7905H10.8199H10.8493H10.8787H10.9081H10.9374H10.9667H10.996H11.0253H11.0545H11.0837H11.1129H11.142H11.1711H11.2002H11.2292H11.2582H11.2871H11.316H11.3449H11.3738H11.4025H11.4313H11.46H11.4887H11.5173H11.5459H11.5744H11.6029H11.6314H11.6598H11.6881H11.7164H11.7446H11.7728H11.801H11.829H11.8571H11.8851H11.913H11.9408H11.9686H11.9964H12.0241H12.0517H12.0792H12.1067H12.1342H12.1616H12.1889H12.2161H12.2433H12.2704H12.2974H12.3244H12.3513H12.3781H12.4049H12.4315H12.4581H12.4847H12.5111H12.5375H12.5638H12.59H12.6162H12.6423H12.6682H12.6941H12.72H12.7457H12.7713H12.7969H12.8224H12.8478H12.8731H12.8983H12.9234H12.9485H12.9734H12.9983H13.023H13.0477H13.0722H13.0967H13.1211H13.1454H13.1696H13.1936H13.2176H13.2415H13.2653H13.2889H13.3125H13.336H13.3593H13.3826H13.4057H13.4288H13.4517H13.4745H13.4972H13.5198H13.5423H13.5647H13.5869H13.6091H13.6311H13.653H13.6748H13.6965H13.718H13.7394H13.7607H13.7819H13.803H13.8239H13.8447H13.8654H13.886H13.9064H13.9267H13.9469H13.9669H13.9869H14.0066H14.0263H14.0458H14.0652H14.0844H14.1035H14.1225H14.1413H14.16H14.1786H14.197H14.2153H14.2334H14.2514H14.2692H14.2869H14.3045H14.3219H14.3391H14.3562H14.3732H14.39H14.4067H14.4232H14.4395H14.4557H14.4717H14.4876H14.5034H14.5189H14.5343H14.5496H14.5647H14.5796H14.5944H14.609H14.6234H14.6377H14.6518H14.6658H14.6796H14.6932H14.7066H14.7199H14.733H14.7459H14.7587H14.7712H14.7837H14.7959H14.808H14.8198H14.8315H14.8431H14.8544H14.8656H14.8766H14.8874H14.898H14.9084H14.9187H14.9287H14.9386H14.9483H14.9578H14.9671H14.9762H14.9852H14.9939H15.0024H15.0108H15.019H15.0269H15.0347H15.0423H15.0496H15.0568H15.0638H15.0705H15.0771H15.0835H15.0896H15.0956H15.1014H15.1069H15.1123H15.1174H15.1223H15.127H15.1315H15.1358H15.1399H15.1438H15.1474H15.1509H15.1541H15.1571H15.1599H15.1625H15.1648H15.167H15.1689H15.1706H15.172H15.1733H15.1743H15.1751H15.1757H15.176C15.176 17.05 15.1761 17.05 15.1761 17.0489Z"
              fill="black"
              stroke="black"
              stroke-width="0.1"
            />
          </svg>
          <span>{{ $t("header.workbench") }}</span>
        </div>
        <div class="purchaseCar" @click="toShoppingCart">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M25.1555 8.99378C25.0152 8.81078 24.7974 8.7037 24.5674 8.7037H9.03211L8.37963 5.58881C8.30804 5.24596 8.00567 5 7.65481 5H5.74074C5.33133 5 5 5.3313 5 5.74074C5 6.15019 5.3313 6.48148 5.74074 6.48148H7.05296L9.87704 19.9667C9.94867 20.3096 10.251 20.5556 10.6019 20.5556H21.7593C22.1687 20.5556 22.5 20.2243 22.5 19.8148C22.5 19.4054 22.1687 19.0741 21.7593 19.0741H11.2037L10.7386 16.8519H22.7778C23.1127 16.8519 23.4064 16.6269 23.4932 16.3028L25.2828 9.63615C25.3429 9.41407 25.2951 9.17607 25.1555 8.99378ZM22.2099 15.3704H10.4283L9.34248 10.1852H23.6017L22.2099 15.3704ZM12.037 21.2963C11.0156 21.2963 10.1852 22.1267 10.1852 23.1481C10.1852 24.1696 11.0156 25 12.037 25C13.0584 25 13.8889 24.1696 13.8889 23.1481C13.8889 22.1267 13.0584 21.2963 12.037 21.2963ZM12.037 23.8889C11.6283 23.8889 11.2963 23.5569 11.2963 23.1481C11.2963 22.7394 11.6283 22.4074 12.037 22.4074C12.4457 22.4074 12.7778 22.7394 12.7778 23.1481C12.7778 23.5569 12.4457 23.8889 12.037 23.8889ZM20.1852 21.2963C19.1638 21.2963 18.3333 22.1267 18.3333 23.1481C18.3333 24.1696 19.1638 25 20.1852 25C21.2066 25 22.037 24.1696 22.037 23.1481C22.037 22.1267 21.2066 21.2963 20.1852 21.2963ZM20.1852 23.8889C19.7765 23.8889 19.4444 23.5569 19.4444 23.1481C19.4444 22.7394 19.7765 22.4074 20.1852 22.4074C20.5939 22.4074 20.9259 22.7394 20.9259 23.1481C20.9259 23.5569 20.5939 23.8889 20.1852 23.8889Z"
              fill="black"
            />
          </svg>
        </div>
        <!-- 会员 未登录或未开通 -->
        <div
          class="vip"
          v-if="!token || (!!userInfo && userInfo.isMember != 1)"
          @click="openBuyMemberVisible"
        >
          {{ $t("modelDetail.ktvip") }}
        </div>
        <!-- 会员 已登录已未开通 -->
        <div class="vip2" v-else @click="$router.push({ path: '/userBuyVip' })">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
          >
            <g filter="url(#filter0_i_110_2405)">
              <path
                d="M7.53172 3.03739C10.7872 1.15785 14.7981 1.15785 18.0536 3.03739C21.309 4.91694 23.3145 8.39048 23.3145 12.1496C23.3145 15.9087 21.309 19.3822 18.0536 21.2618C14.7981 23.1413 10.7872 23.1413 7.53172 21.2618C4.27625 19.3822 2.2708 15.9087 2.2708 12.1496C2.2708 8.39048 4.27625 4.91694 7.53172 3.03739Z"
                fill="url(#paint0_linear_110_2405)"
              />
            </g>
            <g filter="url(#filter1_ii_110_2405)">
              <path
                d="M8.26003 4.29847C11.0647 2.67917 14.5203 2.67917 17.325 4.29847C20.1297 5.91777 21.8575 8.91036 21.8575 12.149C21.8575 15.3876 20.1297 18.3802 17.325 19.9995C14.5203 21.6188 11.0647 21.6188 8.26003 19.9995C5.45532 18.3802 3.72755 15.3876 3.72755 12.149C3.72755 8.91036 5.45532 5.91777 8.26003 4.29847Z"
                fill="url(#paint1_linear_110_2405)"
              />
            </g>
            <g filter="url(#filter2_f_110_2405)">
              <path
                d="M8.58416 4.8596C11.1885 3.35597 14.3973 3.35597 17.0016 4.8596C19.606 6.36324 21.2104 9.14207 21.2104 12.1493C21.2104 15.1566 19.606 17.9354 17.0016 19.4391C14.3973 20.9427 11.1885 20.9427 8.58416 19.4391C5.97979 17.9355 4.37543 15.1566 4.37543 12.1493C4.37543 9.14207 5.97979 6.36324 8.58416 4.8596Z"
                fill="url(#paint2_linear_110_2405)"
              />
            </g>
            <path
              d="M8.99623 5.57318C11.3457 4.21669 14.2404 4.21669 16.59 5.57318C18.9395 6.92967 20.3868 9.43656 20.3868 12.1495C20.3868 14.8625 18.9395 17.3694 16.59 18.7259C14.2404 20.0824 11.3457 20.0824 8.99623 18.7259C6.64672 17.3694 5.19937 14.8625 5.19937 12.1495C5.19937 9.43656 6.64672 6.92967 8.99623 5.57318Z"
              fill="url(#paint3_linear_110_2405)"
              stroke="url(#paint4_linear_110_2405)"
            />
            <path
              d="M8.26474 4.29118C11.0643 2.66514 14.5208 2.66514 17.3203 4.29118C20.0978 5.90445 21.8075 8.92118 21.8075 12.1338C21.8075 15.3465 20.0978 18.3632 17.3203 19.9765C14.5208 21.6025 11.0643 21.6025 8.26474 19.9765C5.48719 18.3632 3.77755 15.3465 3.77755 12.1338C3.77755 8.92118 5.48719 5.90445 8.26474 4.29118Z"
              stroke="url(#paint5_linear_110_2405)"
              stroke-width="0.1"
            />
            <mask
              id="mask0_110_2405"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="4"
              y="3"
              width="17"
              height="17"
            >
              <path
                d="M8.74525 4.76614C11.2495 3.32034 14.3348 3.32034 16.839 4.76614C19.3432 6.21195 20.8858 8.8839 20.8858 11.7755C20.8858 14.6671 19.3432 17.3391 16.839 18.7849C14.3348 20.2307 11.2495 20.2307 8.74525 18.7849C6.24105 17.3391 4.69839 14.6671 4.69839 11.7755C4.69839 8.8839 6.24105 6.21195 8.74525 4.76614Z"
                fill="url(#paint6_linear_110_2405)"
              />
            </mask>
            <g mask="url(#mask0_110_2405)">
              <g filter="url(#filter3_f_110_2405)">
                <path
                  d="M11.8574 11.3696L20.9807 7.29004V16.4875L11.8574 11.3696Z"
                  fill="url(#paint7_linear_110_2405)"
                />
              </g>
              <g filter="url(#filter4_f_110_2405)">
                <path
                  d="M10.0692 10.0829L13.6357 0.747092L20.1393 7.25069L10.0692 10.0829Z"
                  fill="url(#paint8_linear_110_2405)"
                />
              </g>
              <path
                d="M11.8574 11.3696L20.9807 7.29004V16.4875L11.8574 11.3696Z"
                fill="url(#paint9_linear_110_2405)"
              />
              <g filter="url(#filter5_f_110_2405)">
                <path
                  d="M12.2883 12.8899L4.19372 7.02867L12.159 2.42993L12.2883 12.8899Z"
                  fill="url(#paint10_linear_110_2405)"
                />
              </g>
              <g filter="url(#filter6_f_110_2405)">
                <path
                  d="M13.3883 12.7561L4.19358 16.6719L4.35795 7.47591L13.3883 12.7561Z"
                  fill="url(#paint11_linear_110_2405)"
                />
              </g>
            </g>
            <mask id="path-12-inside-1_110_2405" fill="white">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.00249661 10.1387C0.000834922 10.2191 0 10.2997 0 10.3805V11.6403C0 18.6757 5.70324 24.3789 12.7386 24.3789C19.7739 24.3789 25.4771 18.6757 25.4771 11.6403V11.2869C24.8089 14.919 22.5987 18.1336 19.3519 20.0464C15.3203 22.4216 10.3174 22.4216 6.28583 20.0464C2.70066 17.9343 0.379436 14.2349 0.00249661 10.1387Z"
              />
            </mask>
            <g filter="url(#filter7_ii_110_2405)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.00249661 10.1387C0.000834922 10.2191 0 10.2997 0 10.3805V11.6403C0 18.6757 5.70324 24.3789 12.7386 24.3789C19.7739 24.3789 25.4771 18.6757 25.4771 11.6403V11.2869C24.8089 14.919 22.5987 18.1336 19.3519 20.0464C15.3203 22.4216 10.3174 22.4216 6.28583 20.0464C2.70066 17.9343 0.379436 14.2349 0.00249661 10.1387Z"
                fill="url(#paint12_linear_110_2405)"
              />
            </g>
            <path
              d="M0.00249661 10.1387L0.201655 10.1203L-0.197461 10.1345L0.00249661 10.1387ZM25.4771 11.2869H25.6771L25.2804 11.2507L25.4771 11.2869ZM19.3519 20.0464L19.2504 19.8741L19.3519 20.0464ZM6.28583 20.0464L6.18431 20.2188L6.28583 20.0464ZM0.2 10.3805C0.2 10.3011 0.200821 10.2218 0.202454 10.1428L-0.197461 10.1345C-0.199151 10.2163 -0.2 10.2983 -0.2 10.3805H0.2ZM0.2 11.6403V10.3805H-0.2V11.6403H0.2ZM12.7386 24.1789C5.8137 24.1789 0.2 18.5652 0.2 11.6403H-0.2C-0.2 18.7861 5.59278 24.5789 12.7386 24.5789V24.1789ZM25.2771 11.6403C25.2771 18.5652 19.6634 24.1789 12.7386 24.1789V24.5789C19.8843 24.5789 25.6771 18.7861 25.6771 11.6403H25.2771ZM25.2771 11.2869V11.6403H25.6771V11.2869H25.2771ZM25.2804 11.2507C24.6225 14.8264 22.4467 17.9911 19.2504 19.8741L19.4534 20.2188C22.7507 18.2762 24.9952 15.0117 25.6738 11.323L25.2804 11.2507ZM19.2504 19.8741C15.2815 22.2123 10.3562 22.2123 6.38734 19.8741L6.18431 20.2188C10.2785 22.6308 15.3592 22.6308 19.4534 20.2188L19.2504 19.8741ZM6.38734 19.8741C2.85791 17.7948 0.572735 14.1529 0.201655 10.1203L-0.196662 10.157C0.186138 14.3169 2.54342 18.0738 6.18431 20.2188L6.38734 19.8741Z"
              fill="#FFDBCA"
              mask="url(#path-12-inside-1_110_2405)"
            />
            <mask
              id="mask1_110_2405"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="10"
              width="26"
              height="15"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.00249661 10.1377C0.000834922 10.2181 0 10.2987 0 10.3795V11.6394C0 18.6747 5.70324 24.3779 12.7386 24.3779C19.7739 24.3779 25.4771 18.6747 25.4771 11.6394V11.2859C24.8089 14.9181 22.5987 18.1327 19.3519 20.0455C15.3203 22.4206 10.3174 22.4206 6.28583 20.0455C2.70066 17.9333 0.379436 14.2339 0.00249661 10.1377Z"
                fill="url(#paint13_linear_110_2405)"
              />
            </mask>
            <g mask="url(#mask1_110_2405)">
              <g filter="url(#filter8_f_110_2405)">
                <path
                  d="M17.2501 21.3711L16.8457 20.9667C18.7329 19.7872 22.6893 17.3474 23.4172 17.0238C24.1451 16.8621 24.9337 15.878 25.237 15.4062C25.1022 15.878 24.7921 16.943 24.6304 17.4282C24.4686 17.9135 19.6428 20.259 17.2501 21.3711Z"
                  fill="#FFEAAC"
                />
              </g>
              <g filter="url(#filter9_f_110_2405)">
                <path
                  d="M8.55069 21.6753L8.95996 21.2778C7.05003 20.1183 3.046 17.7197 2.30931 17.4017C1.57263 17.2427 0.774548 16.2753 0.467594 15.8115C0.604018 16.2753 0.917792 17.3222 1.0815 17.7992C1.24521 18.2763 6.12917 20.5821 8.55069 21.6753Z"
                  fill="#FFEAAC"
                />
              </g>
            </g>
            <g filter="url(#filter10_ii_110_2405)">
              <path
                d="M1.39845 17.8848C3.19441 21.6257 7.08227 25.2459 11.8066 25.2459H13.7853C15.6015 25.2459 17.1258 24.7995 19.3533 23.5697C21.3136 22.2453 23.4842 19.6818 24.0917 17.8594C23.8988 18.1039 23.0583 19.0573 22.7916 19.2241L14.2151 23.9976C13.3778 24.5214 12.3388 24.5214 11.5015 23.9976L2.95142 19.4388C2.57312 19.2022 1.6227 18.2677 1.39845 17.8848Z"
                fill="url(#paint14_linear_110_2405)"
              />
            </g>
            <path
              d="M22.8403 19.3115L22.8403 19.3116L22.8447 19.3089C22.9218 19.2607 23.0314 19.1624 23.1501 19.0464C23.2711 18.9281 23.4084 18.7843 23.5428 18.6388C23.6218 18.5533 23.7 18.4668 23.7736 18.3842C23.418 19.1531 22.8413 20.0129 22.153 20.8372C21.2952 21.8645 20.2707 22.8285 19.3011 23.4843C17.0855 24.7071 15.5787 25.1459 13.7853 25.1459H11.8066C7.47439 25.1459 3.84088 22.0647 1.91107 18.6504C1.9557 18.6964 2.00108 18.7423 2.04667 18.7876C2.35969 19.0988 2.6988 19.3988 2.89839 19.5236L2.89827 19.5238L2.90437 19.5271L11.4514 24.0843C12.3199 24.626 13.3976 24.6258 14.266 24.0838L22.8403 19.3115Z"
              stroke="url(#paint15_linear_110_2405)"
              stroke-width="0.2"
            />
            <mask
              id="mask2_110_2405"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="2"
              y="18"
              width="22"
              height="8"
            >
              <path
                d="M22.929 19.3815L22.9291 19.3816L22.9333 19.3791C23.0738 19.2961 23.2366 19.1482 23.3856 18.9965C22.6063 20.5657 21.1528 21.9537 19.533 23.2495C18.9383 23.7253 17.967 24.2008 16.9128 24.5576C15.8592 24.9142 14.7349 25.1481 13.8375 25.1481H11.8503C7.72061 25.1481 4.63413 22.8181 2.66575 19.4122C2.73161 19.4641 2.80254 19.513 2.8797 19.5586L2.87958 19.5588L2.88549 19.5618L11.4959 23.9088C12.3669 24.422 13.4469 24.4219 14.3179 23.9084L22.929 19.3815Z"
                fill="url(#paint16_linear_110_2405)"
                stroke="#FEBD70"
                stroke-width="0.2"
              />
            </mask>
            <g mask="url(#mask2_110_2405)">
              <g filter="url(#filter11_f_110_2405)">
                <ellipse
                  cx="4.72553"
                  cy="0.896858"
                  rx="4.72553"
                  ry="0.896858"
                  transform="matrix(0.893693 0.448679 -0.446667 0.8947 5.05176 21.626)"
                  fill="#E46C24"
                />
              </g>
              <g filter="url(#filter12_f_110_2405)">
                <ellipse
                  cx="4.72553"
                  cy="0.896858"
                  rx="4.72553"
                  ry="0.896858"
                  transform="matrix(-0.893693 0.448679 0.446667 0.8947 20.75 21.626)"
                  fill="#E46C24"
                />
              </g>
            </g>
            <g filter="url(#filter13_d_110_2405)">
              <path
                d="M12.4812 19.5661C12.8171 19.3422 13.2547 19.3422 13.5906 19.5661L16.8907 21.7661C17.4844 22.1619 17.4844 23.0344 16.8907 23.4302L13.5906 25.6302C13.2547 25.8542 12.8171 25.8542 12.4812 25.6302L9.18118 23.4302C8.58745 23.0344 8.58745 22.1619 9.18118 21.7661L12.4812 19.5661Z"
                fill="url(#paint17_linear_110_2405)"
              />
            </g>
            <path
              d="M12.4813 20.0524C12.8172 19.8285 13.2548 19.8285 13.5907 20.0524L16.1617 21.7665C16.7555 22.1623 16.7555 23.0347 16.1617 23.4306L13.5907 25.1446C13.2548 25.3685 12.8172 25.3685 12.4813 25.1446L9.91018 23.4306C9.31645 23.0347 9.31645 22.1623 9.91018 21.7665L12.4813 20.0524Z"
              fill="url(#paint18_linear_110_2405)"
            />
            <mask
              id="mask3_110_2405"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="9"
              y="19"
              width="8"
              height="7"
            >
              <path
                d="M12.7995 20.5459C12.9628 20.4427 13.1709 20.4427 13.3342 20.5459L15.91 22.1755C16.2202 22.3718 16.2202 22.8243 15.91 23.0206L13.3342 24.6502C13.1709 24.7535 12.9628 24.7535 12.7995 24.6502L10.2237 23.0206C9.91346 22.8243 9.91346 22.3718 10.2237 22.1755L12.7995 20.5459Z"
                fill="url(#paint19_linear_110_2405)"
                stroke="url(#paint20_linear_110_2405)"
              />
            </mask>
            <g mask="url(#mask3_110_2405)">
              <g filter="url(#filter14_f_110_2405)">
                <path
                  d="M17.513 22.4618L12.9761 19.6035L13.1576 22.9609L17.513 22.4618Z"
                  fill="url(#paint21_linear_110_2405)"
                />
              </g>
              <g filter="url(#filter15_f_110_2405)">
                <path
                  d="M13.0568 25.5006L17.6035 22.5977L13.248 22.7701L13.0568 25.5006Z"
                  fill="url(#paint22_linear_110_2405)"
                />
              </g>
              <g filter="url(#filter16_f_110_2405)">
                <path
                  d="M13.0393 19.7226L8.43945 22.5977L13.0393 22.8699L13.0393 19.7226Z"
                  fill="url(#paint23_linear_110_2405)"
                />
              </g>
            </g>
            <path
              d="M12.5922 20.2188C12.8609 20.0397 13.211 20.0397 13.4797 20.2188L16.0508 21.9329C16.5258 22.2495 16.5258 22.9475 16.0508 23.2642L13.4797 24.9782C13.211 25.1573 12.8609 25.1573 12.5922 24.9782L10.0211 23.2642C9.54614 22.9475 9.54614 22.2495 10.0211 21.9329L12.5922 20.2188Z"
              stroke="url(#paint24_linear_110_2405)"
              stroke-width="0.4"
            />
            <g filter="url(#filter17_di_110_2405)">
              <path
                d="M6.7511 7.48438C6.62887 7.48438 6.52979 7.58346 6.52979 7.70569V8.06394C6.52979 8.18617 6.62887 8.28525 6.7511 8.28525H7.52349C7.61374 8.28525 7.69495 8.34005 7.72872 8.42374L12.1184 17.1068H13.7999L18.4459 7.78852C18.5046 7.64305 18.3976 7.48438 18.2407 7.48438H15.266C15.1758 7.48438 15.0946 7.53917 15.0608 7.62286L13.1644 12.3217C13.0898 12.5064 12.8284 12.5064 12.7539 12.3217L10.8575 7.62286C10.8237 7.53917 10.7425 7.48438 10.6523 7.48438H6.7511Z"
                fill="white"
              />
              <path
                d="M6.72979 7.70569C6.72979 7.69392 6.73933 7.68438 6.7511 7.68438H10.6523C10.661 7.68438 10.6688 7.68965 10.672 7.69771L12.5684 12.3966C12.7103 12.7481 13.208 12.7481 13.3498 12.3966L15.2462 7.69771C15.2495 7.68965 15.2573 7.68438 15.266 7.68438H18.2407C18.2545 7.68438 18.2643 7.69715 18.2616 7.71005L13.6761 16.9068H12.2414L7.91042 8.33985C7.844 8.18564 7.69203 8.08525 7.52349 8.08525H6.7511C6.73933 8.08525 6.72979 8.07571 6.72979 8.06394V7.70569Z"
                stroke="url(#paint25_linear_110_2405)"
                stroke-width="0.4"
              />
            </g>
            <mask
              id="mask4_110_2405"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="6"
              y="7"
              width="13"
              height="11"
            >
              <path
                d="M6.75061 7.48438C6.62838 7.48438 6.5293 7.58346 6.5293 7.70569V8.06394C6.5293 8.18617 6.62838 8.28525 6.75061 8.28525H7.52301C7.61325 8.28525 7.69446 8.34005 7.72824 8.42374L12.1179 17.1068H13.7994L18.4454 7.78852C18.5041 7.64305 18.3971 7.48438 18.2402 7.48438H15.2655C15.1753 7.48438 15.0941 7.53917 15.0603 7.62286L13.1639 12.3217C13.0894 12.5064 12.8279 12.5064 12.7534 12.3217L10.857 7.62286C10.8232 7.53917 10.742 7.48438 10.6518 7.48438H6.75061Z"
                fill="url(#paint26_linear_110_2405)"
              />
            </mask>
            <g mask="url(#mask4_110_2405)">
              <g filter="url(#filter18_f_110_2405)">
                <circle
                  cx="15.6028"
                  cy="10.5823"
                  r="2.21314"
                  fill="white"
                  fill-opacity="0.8"
                />
              </g>
              <g filter="url(#filter19_f_110_2405)">
                <circle cx="11.3987" cy="13.2385" r="2.21314" fill="white" />
              </g>
              <g filter="url(#filter20_f_110_2405)">
                <ellipse
                  cx="8.96301"
                  cy="6.81946"
                  rx="2.87708"
                  ry="2.87708"
                  fill="white"
                />
              </g>
              <g filter="url(#filter21_f_110_2405)">
                <circle
                  cx="12.5046"
                  cy="16.5579"
                  r="2.21314"
                  fill="white"
                  fill-opacity="0.8"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_i_110_2405"
                x="2.271"
                y="1.62793"
                width="21.0435"
                height="21.0439"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="14.9" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_110_2405"
                />
              </filter>
              <filter
                id="filter1_ii_110_2405"
                x="3.72754"
                y="-2.91602"
                width="18.1299"
                height="26.1299"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="3.1" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.582601 0 0 0 0 0.412391 0 0 0 0 0.0086385 0 0 0 0.45 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_110_2405"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="-6" />
                <feGaussianBlur stdDeviation="3.8" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_110_2405"
                  result="effect2_innerShadow_110_2405"
                />
              </filter>
              <filter
                id="filter2_f_110_2405"
                x="3.37549"
                y="2.73145"
                width="18.835"
                height="18.835"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.5"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter3_f_110_2405"
                x="-12.0426"
                y="-16.61"
                width="56.9235"
                height="56.9973"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="11.95"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter4_f_110_2405"
                x="-8.83066"
                y="-18.1529"
                width="47.8698"
                height="47.1359"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="9.45"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter5_f_110_2405"
                x="-4.80615"
                y="-6.57031"
                width="26.0947"
                height="28.46"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="4.5"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter6_f_110_2405"
                x="-16.8066"
                y="-13.5244"
                width="51.1948"
                height="51.1963"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="10.5"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter7_ii_110_2405"
                x="0"
                y="10.1387"
                width="25.4771"
                height="18.2402"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="14.9" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_110_2405"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_110_2405"
                  result="effect2_innerShadow_110_2405"
                />
              </filter>
              <filter
                id="filter8_f_110_2405"
                x="14.8457"
                y="13.4062"
                width="12.3911"
                height="9.96484"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="1"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter9_f_110_2405"
                x="-1.53223"
                y="13.8115"
                width="12.4922"
                height="9.86426"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="1"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter10_ii_110_2405"
                x="1.39844"
                y="17.8594"
                width="22.6934"
                height="8.38672"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="14.9" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 0.717428 0 0 0 0 0.456592 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_110_2405"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.669076 0 0 0 0 0.233046 0 0 0 0 0.137333 0 0 0 0.15 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_innerShadow_110_2405"
                  result="effect2_innerShadow_110_2405"
                />
              </filter>
              <filter
                id="filter11_f_110_2405"
                x="-1.96816"
                y="15.6813"
                width="21.6849"
                height="17.7352"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="3.3"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter12_f_110_2405"
                x="6.08506"
                y="15.6813"
                width="21.6849"
                height="17.7352"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="3.3"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter13_d_110_2405"
                x="7.73584"
                y="18.3984"
                width="10.6001"
                height="8.39941"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="0.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.575374 0 0 0 0 0.162189 0 0 0 0 0.0961767 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_110_2405"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_110_2405"
                  result="shape"
                />
              </filter>
              <filter
                id="filter14_f_110_2405"
                x="11.1761"
                y="17.8035"
                width="8.13711"
                height="6.95742"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="0.9"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter15_f_110_2405"
                x="10.1566"
                y="19.6977"
                width="10.3469"
                height="8.70332"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="1.45"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter16_f_110_2405"
                x="2.63945"
                y="13.9227"
                width="16.1996"
                height="14.7475"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="2.9"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter17_di_110_2405"
                x="6.42979"
                y="7.38437"
                width="13.1326"
                height="10.8221"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.420833 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_110_2405"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_110_2405"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="0.6" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.4 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect2_innerShadow_110_2405"
                />
              </filter>
              <filter
                id="filter18_f_110_2405"
                x="-2.91035"
                y="-7.93086"
                width="37.0263"
                height="37.0268"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="8.15"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter19_f_110_2405"
                x="-7.11445"
                y="-5.27461"
                width="37.0263"
                height="37.0268"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="8.15"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter20_f_110_2405"
                x="-10.2141"
                y="-12.3576"
                width="38.3544"
                height="38.3539"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="8.15"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <filter
                id="filter21_f_110_2405"
                x="-6.0085"
                y="-1.95527"
                width="37.0263"
                height="37.0268"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feGaussianBlur
                  stdDeviation="8.15"
                  result="effect1_foregroundBlur_110_2405"
                />
              </filter>
              <linearGradient
                id="paint0_linear_110_2405"
                x1="10.5386"
                y1="1.33645"
                x2="16.419"
                y2="21.3832"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFF9BE" />
                <stop offset="0.373114" stop-color="#FFDE60" />
                <stop offset="0.728303" stop-color="#FF7E1B" />
                <stop offset="1" stop-color="#FF4800" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_110_2405"
                x1="19.4755"
                y1="3.69459"
                x2="7.71989"
                y2="19.154"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FCEEBB" />
                <stop offset="1" stop-color="#E45B25" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_110_2405"
                x1="12.7929"
                y1="2.42969"
                x2="12.7929"
                y2="26.3431"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.165284" stop-color="#FFDF8F" />
                <stop offset="0.701738" stop-color="#FA8466" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_110_2405"
                x1="12.7931"
                y1="2.80371"
                x2="12.7931"
                y2="25.7974"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.143333" stop-color="#FFF9E4" />
                <stop offset="0.324385" stop-color="#FFE70C" />
                <stop offset="0.599583" stop-color="#EB2C0E" />
                <stop offset="0.744424" stop-color="#FF7E97" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_110_2405"
                x1="12.7931"
                y1="2.80371"
                x2="12.7931"
                y2="21.4954"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.717887" stop-color="#FA593F" stop-opacity="0" />
                <stop offset="0.962759" stop-color="#FE715A" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_110_2405"
                x1="12.7925"
                y1="1.60352"
                x2="8.69326"
                y2="21.4133"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.109532" stop-color="white" />
                <stop offset="0.376007" stop-color="#FFE500" />
                <stop offset="0.505847" stop-color="white" />
                <stop offset="0.92394" stop-color="#FFCF24" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_110_2405"
                x1="12.7921"
                y1="2.42969"
                x2="12.7921"
                y2="25.4234"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.165284" stop-color="#FFB948" />
                <stop offset="0.835258" stop-color="#ED4800" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_110_2405"
                x1="22.2417"
                y1="11.4437"
                x2="10.7448"
                y2="15.4491"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.616704" stop-color="#FE936C" />
                <stop offset="1" stop-color="#FBB776" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_110_2405"
                x1="16.9977"
                y1="3.92467"
                x2="10.2687"
                y2="11.0275"
                gradientUnits="userSpaceOnUse"
              >
                <stop
                  offset="0.0490945"
                  stop-color="#FBB776"
                  stop-opacity="0"
                />
                <stop offset="0.224884" stop-color="#FFECBA" />
                <stop offset="0.525913" stop-color="#FFECBA" />
                <stop offset="1" stop-color="#FBB776" stop-opacity="0" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_110_2405"
                x1="21.0163"
                y1="12.7106"
                x2="10.7448"
                y2="15.4491"
                gradientUnits="userSpaceOnUse"
              >
                <stop
                  offset="0.0590908"
                  stop-color="#FBB776"
                  stop-opacity="0"
                />
                <stop
                  offset="0.522305"
                  stop-color="#FE936C"
                  stop-opacity="0.7"
                />
              </linearGradient>
              <linearGradient
                id="paint10_linear_110_2405"
                x1="3.81988"
                y1="11.4019"
                x2="12.418"
                y2="3.64489"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.371475" stop-color="#F6B976" stop-opacity="0" />
                <stop offset="0.954579" stop-color="#F6D470" />
              </linearGradient>
              <linearGradient
                id="paint11_linear_110_2405"
                x1="7.74857"
                y1="19.2462"
                x2="5.53263"
                y2="7.88008"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.371475" stop-color="#E94025" />
                <stop offset="0.954579" stop-color="#F37828" />
              </linearGradient>
              <linearGradient
                id="paint12_linear_110_2405"
                x1="20.595"
                y1="16.7178"
                x2="9.3339"
                y2="25.5037"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFE600" />
                <stop offset="0.983461" stop-color="#FFE570" />
              </linearGradient>
              <linearGradient
                id="paint13_linear_110_2405"
                x1="20.595"
                y1="16.7168"
                x2="9.3339"
                y2="25.5027"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#F0CA40" />
                <stop offset="0.983461" stop-color="#EFC454" />
              </linearGradient>
              <linearGradient
                id="paint14_linear_110_2405"
                x1="12.9441"
                y1="13.0968"
                x2="12.9441"
                y2="26.4614"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFF733" />
                <stop offset="0.573591" stop-color="#FFBA2E" />
                <stop offset="0.907083" stop-color="#DA0003" />
              </linearGradient>
              <linearGradient
                id="paint15_linear_110_2405"
                x1="0.916061"
                y1="17.9081"
                x2="22.5666"
                y2="24.8576"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FD7800" />
                <stop offset="0.236236" stop-color="#FFFBFA" />
                <stop offset="0.635577" stop-color="#E02C00" />
                <stop offset="0.863336" stop-color="#FF8170" />
                <stop offset="1" stop-color="#FFBD3A" />
              </linearGradient>
              <linearGradient
                id="paint16_linear_110_2405"
                x1="16.5995"
                y1="20.2797"
                x2="17.9726"
                y2="24.4581"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF9F4E" />
                <stop offset="0.7624" stop-color="#ED4800" />
              </linearGradient>
              <linearGradient
                id="paint17_linear_110_2405"
                x1="13.8416"
                y1="19.3802"
                x2="10.8417"
                y2="26.8653"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFF4D6" />
                <stop offset="0.306234" stop-color="#FFD869" />
                <stop offset="0.623653" stop-color="#FFE59A" />
                <stop offset="0.816001" stop-color="#FFF0C6" />
              </linearGradient>
              <linearGradient
                id="paint18_linear_110_2405"
                x1="13.036"
                y1="19.6826"
                x2="12.9368"
                y2="28.0539"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.362995" stop-color="#F9DD4D" />
                <stop offset="0.533462" stop-color="#E94025" />
                <stop offset="1" stop-color="#E94025" />
              </linearGradient>
              <linearGradient
                id="paint19_linear_110_2405"
                x1="13.0668"
                y1="19.7852"
                x2="13.0668"
                y2="26.7058"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.165284" stop-color="#FFF7CE" />
                <stop offset="0.629557" stop-color="#E94025" />
              </linearGradient>
              <linearGradient
                id="paint20_linear_110_2405"
                x1="13.0668"
                y1="19.7852"
                x2="13.0668"
                y2="25.411"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.717887" stop-color="#FF6F58" stop-opacity="0" />
                <stop offset="0.962759" stop-color="#FE715A" />
              </linearGradient>
              <linearGradient
                id="paint21_linear_110_2405"
                x1="16.5477"
                y1="25.4154"
                x2="12.3846"
                y2="17.8422"
                gradientUnits="userSpaceOnUse"
              >
                <stop
                  offset="0.383765"
                  stop-color="#FDDE48"
                  stop-opacity="0.86"
                />
                <stop offset="0.550386" stop-color="#FDDE48" stop-opacity="0" />
              </linearGradient>
              <linearGradient
                id="paint22_linear_110_2405"
                x1="14.2462"
                y1="27.2254"
                x2="15.8511"
                y2="21.6174"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.346376" stop-color="#FA5C14" />
                <stop offset="0.806058" stop-color="#FDC53B" />
              </linearGradient>
              <linearGradient
                id="paint23_linear_110_2405"
                x1="12.4686"
                y1="20.0807"
                x2="9.81385"
                y2="22.856"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.732238" stop-color="white" />
              </linearGradient>
              <linearGradient
                id="paint24_linear_110_2405"
                x1="13.1252"
                y1="18.1776"
                x2="12.9289"
                y2="26.4617"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.158385" stop-color="#FFD06B" />
                <stop offset="0.39291" stop-color="#FF8383" />
                <stop offset="0.576431" stop-color="white" />
                <stop offset="1" stop-color="#FFA318" />
              </linearGradient>
              <linearGradient
                id="paint25_linear_110_2405"
                x1="12.496"
                y1="7.48437"
                x2="12.496"
                y2="17.1068"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#DAEAD6" />
                <stop offset="0.329299" stop-color="#FFF503" />
                <stop offset="1" stop-color="#FF6F6F" />
              </linearGradient>
              <linearGradient
                id="paint26_linear_110_2405"
                x1="10.5129"
                y1="4.16467"
                x2="14.5738"
                y2="19.5548"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.187569" stop-color="#FFE594" />
                <stop offset="0.424268" stop-color="#F1D16E" />
                <stop offset="0.524318" stop-color="#FFF9B5" />
                <stop offset="0.634671" stop-color="#FFF8A6" />
                <stop offset="0.793891" stop-color="#FFE88B" />
              </linearGradient>
            </defs>
          </svg>
          <span class="time"
            >{{ !!userInfo ? userInfo.memberExpiryTime : ""
            }}{{ $t("header.becomeDue") }}</span
          >
          <span class="renew">{{ $t("header.renew") }}</span>
        </div>
        <div class="login" v-if="!token" @click="handleHeadreLogin">
          {{ $t("header.login") }}
        </div>
        <!-- 已登录 -->
        <el-dropdown
          v-else
          trigger="click"
          :tabindex="9999"
          @command="handleCommand"
        >
          <span class="el-dropdown-link">
            <div class="user-box flex-c">
              <el-image
                class="avatar-img mr10"
                fit="cover"
                :src="
                  !!userInfo && !!userInfo.avatar
                    ? userInfo.avatar
                    : defaultAvatar
                "
              />
              <!-- <img class="avatar-img mr10" :src="!!userInfo && !!userInfo.avatar ? userInfo.avatar : defaultAvatar" alt=""> -->
              <div class="flex-c">
                <div>{{ !!userInfo ? userInfo.nickName : "" }}</div>
                <i class="el-icon-caret-bottom ml10"></i>
              </div>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userInfo">
              <!-- 个人中心 -->
              {{ $t("login.grzx") }}
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <!-- 退出登录 -->
              {{ $t("login.tcdl") }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <!-- 导航栏 end -->

    <!-- 上传模型弹框 -->
    <el-dialog
      :title="$t('modelPublish.title')"
			:append-to-body="true"
      :close-on-click-modal="false"
      :visible="uploadModelVisible"
      width="40%"
      @close="uploadModelClose"
			@closed="isCancelModel = false"
      >
    >
      <el-divider />
      <div style="padding: 0 20px 30px 20px">
        <!-- 模型来源 -->
        <div>
          <div class="model-title mb20">
            <!-- 模型来源 -->
            <span class="c_red">*</span> {{ $t("modelPublish.mxly") }}
          </div>
          <el-radio-group
            v-model="modelPublishForm.modelSource"
            size="medium"
            class="model-source"
          >
            <!-- 原创模型 -->
            <el-radio-button label="1">{{
              $t("modelPublish.ycmx")
            }}</el-radio-button>
            <!-- 分享模型 -->
            <el-radio-button label="2" class="ml20">{{
              $t("modelPublish.fxmx")
            }}</el-radio-button>
            <!-- 二次创作模型 -->
            <el-radio-button label="3" class="ml20">{{
              $t("modelPublish.ecczmx")
            }}</el-radio-button>
          </el-radio-group>
          <div class="mt20 flex-c-b model-bor">
            <!-- 版权声明 -->
            <div class="f14">
              <span class="c_red">* </span> {{ $t("modelPublish.bqsm") }}
            </div>
            <div @click="showCopyrightList = true">
              <!-- 请选择知识共享许可协议 -->
              {{
                !!modelCopyrightName
                  ? modelCopyrightName
                  : $t("modelPublish.xzgxxy")
              }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <el-divider />
        </div>
        <!-- 模型来源 end-->
        <div v-show="modelPublishForm.modelSource == 1 || modelPublishForm.modelSource == 3">
          <!-- 定价 -->
          <div>
            <div class="model-title mb20">
              <span class="c_red">*</span> {{ $t("modelPublish.dj") }}
            </div>
            <el-radio-group
              size="medium"
              v-model="modelPublishForm.modelChargeStatu"
              fill="#FFEBEB"
              text-color="#C32D30"
            >
              <el-radio :label="0" fill="#FFEBEB" text-color="#C32D30">
                <!-- 收费 -->
                {{ $t("modelPublish.sf") }}
              </el-radio>
              <el-radio :label="1" fill="#FFEBEB" text-color="#C32D30">
                <!-- 免费 -->
                {{ $t("modelPublish.mf") }}
              </el-radio>
            </el-radio-group>
            <div v-show="modelPublishForm.modelChargeStatu == 0" class="mt20">
              <el-input
                v-model="modelPublishForm.modelPrice"
                @input="inputZybCallback"
                :placeholder="$t('modelPublish.srzybjg')"
              ></el-input>
            </div>
            <el-divider />
          </div>
          <!-- 定价 end -->
          <!-- 原创证明 -->
          <div>
            <div class="model-title mb20">
              <!-- 原创证明 -->
              <span class="c_red">*</span> {{ $t("modelPublish.yczm") }}
              <span class="f16 c_999">{{ $t("modelPublish.yczm_tips") }}</span>
            </div>
            <div class="mt20">
              <div class="model-proof-list flex-c">
                <template v-for="(item, index) in modelProofList">
                  <div :key="index" class="model-proof-item">
                    <div class="del-box">
                      <i
                        class="el-icon-delete del-icon"
                        @click="delModelProofImg(index)"
                      ></i>
                    </div>
                    <el-image
                      :src="item.url"
                      fit="cover"
                      :style="
                        index == modelProofList.length - 1
                          ? 'margin-right: 0;'
                          : ''
                      "
                    ></el-image>
                  </div>
                </template>

                <UploadImg
									ref="modelProofRef"
                  v-show="modelProofList.length < 9"
                  :labelText="$t('modelPublish.sczm')"
                  @onUploadSuccess="handleModelProofSuccess"
                  width="130px"
                  height="130px"
									:limit="9"
                >
                </UploadImg>
              </div>
            </div>
            <el-divider />
          </div>
          <!-- 原创证明 end -->
        </div>
        <!-- 上传模型 -->
        <div>
          <div class="model-title mb20">
            <!--上传模型 -->
            <span class="c_red">*</span> {{ $t("modelPublish.scmx") }}
          </div>
          <div class="mode-file-list">
            <template v-for="(item, index) in modelFilesList">
              <div :key="index + item['fileId']" class="mode-file-item flex-c">
                <div v-show="!!item.pathThumb" class="file-thumb">
                  <div class="del-box">
                    <i
                      class="el-icon-delete del-icon"
                      @click="delModelFilesImg(index)"
                    ></i>
                  </div>
                  <el-image
                    style="width: 80px; height: 80px; border-radius: 4px"
                    :src="item.pathThumb"
                    fit="cover"
                  ></el-image>
                </div>
                <UploadImg
                  v-show="!item.pathThumb"
                  :labelText="$t('common.addImg')"
                  @onUploadSuccess="handleModelFilesImgSuccess($event, item)"
                  width="80px"
                  height="80px"
                >
                </UploadImg>
                <div class="mode-file-info ml20">
                  <div class="flex-c-b" style="width: 100%">
                    <div class="file-name" style="flex: 1">
                      {{ item.fileName }}
                    </div>
                    <div class="ml10">
                      <span v-if="!item['fileId'] && !isUploadModelFilesErr">{{
                        $t("common.zzsc")
                      }}</span>
                      <span v-if="!!item['fileId']">{{
                        $t("modelPublish.scwc")
                      }}</span>
                      <span v-if="!item['fileId'] && isUploadModelFilesErr">{{
                        $t("modelPublish.scsb")
                      }}</span>
                      <i
                        v-show="!!item['fileId'] || isUploadModelFilesErr"
                        class="el-icon-delete del-icon ml10"
                        @click="delModelFile(index, item)"
                      ></i>
                    </div>
                  </div>
                  <div style="width: 100%">
                    <el-progress
                      :percentage="item['percent']"
                      :stroke-width="3"
                      color="#C32D30"
                      :show-text="false"
                    ></el-progress>
                    <div class="model-file-size">
                      {{ filesize(item["modelFileProgress"]) }}/{{
                        filesize(item["size"])
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="mt20 upload-box">
						<!--  :before-upload="(file) => modelFileBeforeUpload(file)" -->
            <el-upload
							ref="modelUploadRef"
              action
              :show-file-list="false"
              :http-request="uploadModelFile"
							:on-change="handleFileChange"
              :on-progress="(res, file) => modelFileUploadProgress(res, file)"
              :on-success="(res, file) => handleModelFileSuccess(res, file)"
              :on-error="triggerUploadError"
              :headers="{ Authorization: token }"
              :data="uploadFileParamData"
              :accept="acceptFile"
            >
              <div class="flex-c-c" style="width: 100%; height: 58px">
                <i class="el-icon-plus upload-icon"></i>
                <div class="upload-text1">{{ $t("modelPublish.add") }}</div>
              </div>
            </el-upload>
          </div>
          <div class="f14 c_666 mt20">
            <!-- 每次最多可上传500MB大小的文件-->
            {{ $t("modelPublish.file_tips01") }}
          </div>
          <div class="f14 c_666 mt10">
            <!-- 目前支持的模型文件格式: .stl,.obj,.ply,.3mf-->
            {{ $t("modelPublish.file_tips02") }}
            <span>{{ acceptFile }}</span>
          </div>
          <el-divider />
        </div>
        <!-- 上传模型 end -->
        <!-- 模型名称 -->
        <div>
          <div class="model-title mb20">
            <span class="c_red">*</span> {{ $t("modelPublish.mxmc") }}
          </div>
          <div class="mt20 flex-c-b">
            <el-input
              type="text"
              v-model="modelPublishForm.modelName"
              :placeholder="$t('modelPublish.mxmc_placeholder')"
              maxlength="60"
              show-word-limit
            ></el-input>
          </div>
          <el-divider />
        </div>
        <!-- 模型名称 end -->
        <!-- 模型类别 -->
        <div>
          <div class="model-title mb20">
            <span class="c_red">*</span> {{ $t("modelPublish.mxlb") }}
          </div>
          <div class="mt20">
            <!-- <el-input
              v-model="modelPublishForm.modelClass"
              placeholder="请选择模型类别"
              disabled
              suffix-icon="el-icon-arrow-right"
            ></el-input> -->
            <!-- {{modelClass}} -->
            <el-select
              v-model="modelPublishForm.modelClass"
              :placeholder="$t('modelPublish.mxlb_placeholder')"
              style="width: 100%"
            >
              <el-option
                v-for="item in copyModelClass"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </div>
          <el-divider />
        </div>
        <!-- 模型类别 end -->
        <!-- 隐私设定 -->
        <div>
          <div class="model-title mb20">
            <span class="c_red">*</span> {{ $t("modelPublish.yssz") }}
          </div>
          <el-radio-group
            size="medium"
            v-model="modelPublishForm.modelPrivacy"
            fill="#FFEBEB"
            text-color="#C32D30"
          >
            <el-radio :label="0" fill="#FFEBEB" text-color="#C32D30">{{
              $t("modelPublish.gk")
            }}</el-radio>
            <el-radio :label="1" fill="#FFEBEB" text-color="#C32D30">{{
              $t("modelPublish.zy")
            }}</el-radio>
          </el-radio-group>
          <el-divider />
        </div>
        <!-- 隐私设定 end -->
        <!-- 图集 -->
        <div>
          <div class="model-title mb20">
            <span class="c_red">*</span> {{ $t("modelPublish.img_list") }}
            <span class="f16 c_999">{{
              $t("modelPublish.img_list_tips")
            }}</span>
          </div>
          <div class="mt20">
            <div class="model-proof-list flex-c">
              <template v-for="(item, index) in modelDisplayList">
                <div :key="index" class="model-proof-item">
                  <div class="del-box">
                    <i
                      class="el-icon-delete del-icon"
                      @click="delModelDisplay(index)"
                    ></i>
                  </div>
                  <el-image
                    :src="item.url"
                    fit="cover"
                    :style="
                      index == modelDisplayList.length - 1
                        ? 'margin-right: 0;'
                        : ''
                    "
                  ></el-image>
                </div>
              </template>

              <UploadImg
								ref="modelDisplayRef"
                v-show="modelDisplayList.length < 10"
                :labelText="$t('modelPublish.sctj')"
                @onUploadSuccess="handleModelDisplayList"
                width="130px"
                height="130px"
                :multiplePics="true"
								:limit="10"
              >
              </UploadImg>
            </div>
          </div>
          <el-divider />
        </div>
        <!-- 图集 end -->
        <!-- 描述 -->
        <div>
          <div class="model-title mb20">{{ $t("modelPublish.desc") }}</div>
          <div class="mt20">
            <el-input
              rows="4"
              type="textarea"
              v-model="modelPublishForm.modelIntroduce"
              :placeholder="$t('modelPublish.desc_placeholder')"
            >
            </el-input>
          </div>
        </div>
        <!-- 描述 end -->
        <div class="button flex-c-c mt40">
          <div class="cancel" @click="uploadModelClose('cancel')">
            {{ $t("common.cancel") }}
          </div>
          <div class="comfirm" @click="handleSubimtModel('uploadSubmit')">
            {{ $t("common.submit") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 上传模型弹框 end-->

    <!-- 注册弹框 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="registerVisible"
      class="register-dialog"
      width="460px"
    >
      <div slot="title" class="dialog-title">
        <div class="f30 fwb mb10">注册你的章鱼核账号</div>
        <div @click="goLogin" class="danger-color f16 flex-c">
          已有账号？前往登录
          <span class="plr4 radius20 d32-bg ml10 f12">
            <i class="el-icon-arrow-right c_fff"></i>
          </span>
        </div>
      </div>
      <div class="pd20">
        <div style="width: 195px" class="flex-c radius4 pd5 f5-bg">
          <div
            class="regist"
            :style="{ background: isPhoneRegist ? '#fff' : '' }"
            @click="setPhoneOrEmailRegist(true)"
          >
            手机注册
          </div>
          <div
            class="regist ml10"
            :style="{ background: isPhoneRegist ? '' : '#fff' }"
            @click="setPhoneOrEmailRegist(false)"
          >
            邮箱注册
          </div>
        </div>
        <div v-if="isPhoneRegist">
          <el-input
            class="mt20"
            type="text"
            v-model="registerInfo.phone"
            placeholder="输入手机号"
          >
            <template slot="prepend"
              ><div style="margin-right: -20px">+86</div></template
            >
          </el-input>
          <el-input
            class="mt10"
            v-model="registerInfo.code"
            placeholder="请输入验证码"
          >
            <template slot="prepend">
              <div style="margin-right: -14px">
                <i class="el-icon-s-grid f20"></i>
              </div>
            </template>
            <template slot="append">
              <div class="send-captcha" @click="getCaptcha()">获取验证码</div>
            </template>
          </el-input>
        </div>
        <div v-else>
          <el-input
            class="mt20"
            type="text"
            v-model="registerInfo.email"
            placeholder="输入邮箱"
          >
            <template slot="prepend"><i class="el-icon-user f20"></i></template>
          </el-input>
          <el-input
            class="mt10"
            v-model="registerInfo.passWord"
            placeholder="输入密码"
          >
            <template slot="prepend"><i class="el-icon-lock f20"></i></template>
            <template slot="append"> <i class="el-icon-view f20"></i></template>
          </el-input>
        </div>
        <div class="button flex-c-b mt40">
          <div class="loginComfrim" style="width: 40%; border-radius: 10px">
            上一步
          </div>
          <div class="comfirm ml20" style="width: 60%; border-radius: 10px">
            注册
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 注册弹框 end-->

    <!-- 登录弹框 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="loginVisible"
      :before-close="loginClose"
      append-to-body
      :close-on-click-modal="false"
      @open="openLoginDialog"
      class="login-dialog"
      width="500px"
    >
      <div slot="title" class="dialog-title">
        <el-image
          @click="goScanCode(1)"
          class="lognTab"
          :src="require('@/assets/images/login/qrcode.png')"
        ></el-image>
        <!-- 登录你的章鱼核账号 -->
        <div class="f30 fwb">{{ $t("login.title") }}</div>
        <div v-if="false" @click="goRegist" class="danger-color f16 flex-c">
          <!--  没有账号？免费注册  -->
          {{ $t("login.myzhmfzc") }}
          <span class="plr4 radius20 d32-bg ml10 f12">
            <i class="el-icon-arrow-right c_fff"></i>
          </span>
        </div>
      </div>
      <div style="padding: 20px 30px">
        <div style="width: 400px" class="flex-c radius4 pd5 f5-bg">
          <div
            class="regist"
            :style="{ background: isPhoneLogin == 1 ? '#fff' : '' }"
            @click="setPhoneOrEmailLogin(1)"
          >
            <!-- 手机验证码登录 -->
            {{ $t("login.sjyzmdl") }}
          </div>
          <div
            class="regist ml10"
            :style="{ background: isPhoneLogin == 2 ? '#fff' : '' }"
            @click="setPhoneOrEmailLogin(2)"
          >
            <!-- 邮箱验证码登录 -->
            {{ $t("login.yxyzmdl") }}
          </div>
          <div
            class="regist ml10"
            :style="{ background: isPhoneLogin == 3 ? '#fff' : '' }"
            @click="setPhoneOrEmailLogin(3)"
          >
            <!-- 账号密码登录 -->
            {{ $t("login.zhmmdl") }}
          </div>
        </div>
        <!-- 手机验证码登录 -->
        <div v-if="isPhoneLogin == 1">
          <el-input
            class="mt20"
            type="text"
            v-model="loginInfo.phone"
            :placeholder="$t('login.qsrsjh')"
          >
            <template v-if="lang == 'cn'" slot="prepend">
              <div style="margin-right: -20px">+86</div>
            </template>
            <template v-else slot="prepend">
              <el-select v-model="areaNumActive" style="width: 85px;">
								<template v-for="item in areaNum">
									<el-option :key="item.code" :value="'+'+item.code" class="flex-c">
										<el-image class="mr10" :src="`/images/national_flag/${item.dh}.png`" fit="contain" style="width: 32px; height: 24px;"></el-image>
										+{{item.code}}
									</el-option>
								</template>
							</el-select>
            </template>
          </el-input>
          <el-input
            class="mt10"
            v-model="loginInfo.code"
            :placeholder="$t('login.qsryzm')"
          >
            <template slot="prepend">
              <div style="margin-right: -14px">
                <i class="el-icon-s-grid f20"></i>
              </div>
            </template>
            <template slot="append">
              <div
                v-if="!timerLoading && timerNum == 60"
                class="send-captcha"
                @click="getCaptcha"
              >
                {{ $t("login.hqyzm") }}
              </div>
              <div v-else-if="timerLoading">{{ $t("login.fsz") }}</div>
              <div v-else-if="!timerLoading && timerNum != 0">
                {{ timerNum }}{{ $t("login.khq") }}
              </div>
            </template>
          </el-input>
          <!-- <el-radio v-model="isAutoLogin">下次自动登录</el-radio> -->
        </div>
        <!-- 邮箱验证码登录 -->
        <div v-else-if="isPhoneLogin == 2">
          <el-input
            class="mt20"
            type="text"
            v-model="loginInfo.phone"
            :placeholder="$t('login.qsryx')"
          >
            <template slot="prepend">
              <div style="margin-right: -14px">
                <i class="el-icon-message" style="font-size: 18px"></i>
              </div>
            </template>
          </el-input>
          <el-input
            class="mt10"
            v-model="loginInfo.code"
            :placeholder="$t('login.qsryzm')"
          >
            <template slot="prepend">
              <div style="margin-right: -14px">
                <i class="el-icon-s-grid f20"></i>
              </div>
            </template>
            <template slot="append">
              <div
                v-if="!timerLoading && timerNum == 60"
                class="send-captcha"
                @click="getCaptcha"
              >
                {{ $t("login.hqyzm") }}
              </div>
              <div v-else-if="timerLoading">{{ $t("login.fsz") }}</div>
              <div v-else-if="!timerLoading && timerNum != 0">
                {{ timerNum }}{{ $t("login.khq") }}
              </div>
            </template>
          </el-input>
          <!-- <el-radio v-model="isAutoLogin">下次自动登录</el-radio> -->
        </div>
        <!-- 账号密码登录 -->
        <div v-else>
          <el-input
            class="mt20"
            type="text"
            v-model="loginInfo.phone"
            :placeholder="$t('login.srsjhOryx')"
          >
            <template slot="prepend"><i class="el-icon-user f20"></i></template>
          </el-input>
          <el-input
            class="mt10"
            v-model="loginInfo.passWord"
            show-password
            :placeholder="$t('login.srndmm')"
          >
            <template slot="prepend"><i class="el-icon-lock f20"></i></template>
            <!-- 忘记密码? -->
            <template slot="append">
              <span @click="handleWangJi" style="cursor: pointer">{{
                $t("login.wjmm")
              }}</span></template
            >
          </el-input>
        </div>

        <div v-if="false" class="mt10 flex-c">
          <div
            class="check"
            :class="nextLogin ? 'on' : ''"
            @click="nextLogin = !nextLogin"
          >
            <i v-if="nextLogin" class="el-icon-check"></i>
          </div>
          <!-- 下次自动登录 -->
          <span class="ml5 c_666" @click="handleZiDongLogin">{{
            $t("login.xczddl")
          }}</span>
        </div>
        <div class="button flex-c-c mt30">
          <!-- 登录 -->
          <div
            class="comfirm"
            style="width: 100%; border-radius: 10px"
            @click="handleLogin"
          >
            {{ $t("login.loginText") }}
          </div>
        </div>
        <div class="mt10 flex-c mb20">
          <div
            class="radius30 check"
            :class="agreeWith ? 'on' : ''"
            @click="agreeWith = !agreeWith"
          >
            <i v-if="agreeWith" class="el-icon-check"></i>
          </div>
          <div
            class="ml5 c_666"
            @click="agreeWith = !agreeWith"
            style="flex: 1"
          >
            <!-- 我已阅读并同意章鱼核 -->
            {{ $t("login.agreementText01") }}
            <span
              class="danger-color cursor"
              @click.stop="toTapUrl('/agreement', { type: 1 })"
            >
              <!-- 《用户协议》 -->
              {{ $t("login.agreementText02") }}
            </span>
            {{ $t("login.agreementText03")
            }}<span
              class="danger-color cursor"
              @click.stop="toTapUrl('/agreement', { type: 2 })"
            >
              <!-- 《隐私政策》 -->
              {{ $t("login.agreementText04") }}
            </span>
          </div>
        </div>
        <div class="mt60">
          <!-- 其他登录方式 -->
          <el-divider class="other-login">{{
            $t("login.otherLogin")
          }}</el-divider>
        </div>
        <div v-if="lang == 'cn'" class="button flex-c-c mt30">
          <div class="loginComfrim" @click="goScanCode(2)" style="width: 33%">
            <el-image
              style="width: 23px; height: 18px"
              class="mr10 ml10"
              :src="require('@/assets/images/login/wx.png')"
            ></el-image>
            <!-- 微信登录 -->
            <span style="flex: 1">{{ $t("login.wxLogin") }}</span>
          </div>
          <div
            class="loginComfrim ml20"
            @click="openBindView"
            style="width: 33%"
          >
            <el-image
              style="width: 15px; height: 18px"
              class="mr10 ml10"
              :src="require('@/assets/images/login/qq.png')"
            ></el-image>
            <!-- QQ登录 -->
            <span style="flex: 1">{{ $t("login.qqLogin") }}</span>
          </div>
          <div
            class="loginComfrim ml20"
            @click="openWeiBoView"
            style="width: 33%"
          >
            <el-image
              style="width: 23px; height: 21px"
              class="mr10 ml10"
              :src="require('@/assets/images/login/xinlangweibo.png')"
            ></el-image>
            <!-- 微博登录 -->
            <span style="flex: 1">{{ $t("login.weiboLogin") }}</span>
          </div>
        </div>
        <div v-else class="button flex-c-c mt30">
          <el-button
            type="primary"
            @click="onFBSignSuccess"
            :loading="FacebookLoading"
            >Facebook Login</el-button
          >
          <el-button
            type="primary"
            class="ml30"
            @click="loginGoogle.requestCode()"
            :loading="GoogleLoading"
            >Sign in with Google</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 登录弹框 end-->

    <!-- 扫码登录 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="scanCodeVisible"
      :show-close="false"
      :before-close="
        () => {
          loginClose();
          scanCodeVisible = false;
        }
      "
      class="login-dialog"
      width="500px"
    >
      <div slot="title" class="dialog-title">
        <el-image
          @click="
            scanCodeVisible = false;
            loginVisible = true;
          "
          class="lognTab"
          :src="require('@/assets/images/login/tabpc.png')"
        >
        </el-image>
        <!-- 扫码登录 -->
        <div class="f30 fwb flex-c-c">{{ $t("header.smdl") }}</div>
      </div>
      <div class="pd20 t_center">
        <div
          class="flex-c-c"
          :style="`font-size: ${lang == 'cn' ? '20' : '18'}px;`"
        >
          <!-- 请使用{{ scanCodeType == 1 ? "章鱼核移动端" : "微信" }}扫描二维码 -->
          {{ $t("header.qsy")
          }}{{ scanCodeType == 1 ? $t("common.zyhydd") : $t("common.weChat")
          }}{{ $t("header.smewm") }}
        </div>
        <!-- 二维码 -->
        <div v-show="scanCodeType == 1" class="qr-code">
          <!-- App扫码登录二维码 -->
          <el-image :src="qrCode"></el-image>
          <!-- App是否扫码二维码 -->
          <div v-show="isScanQrCode" class="qr-code-shade flex-c-c">
            <div>
              <img
                class="success-img"
                src="@/assets/images/pay/success.png"
                alt=""
              />
              <div class="text mt10">{{ $t("login.smcg") }}</div>
              <div class="text">{{ $t("login.qzsjsqr") }}</div>
            </div>
          </div>
        </div>
        <!-- 微信登录二维码 -->
        <div v-show="scanCodeType == 2" id="wxLogin_container"></div>
        <!-- 自动登录 -->
        <div v-show="scanCodeType != 2 && false" class="mt10 flex-c-c mb20">
          <div
            class="radius30 check"
            :class="autoLogin ? 'on' : ''"
            @click="autoLogin = !autoLogin"
            style="width: 20px; height: 20px; font-size: 16px"
          >
            <i v-if="autoLogin" class="el-icon-check"></i>
          </div>
          <span
            class="ml5 c_666"
            @click="handleAutoLogin30"
            style="font-size: 20px"
            >30天内自动登录</span
          >
        </div>
      </div>
    </el-dialog>
    <!-- 扫码登录 end-->

    <!-- 模型版权声明列表 start -->
    <el-dialog
      :title="$t('modelPublish.bqsm')"
      :modal-append-to-body="false"
			:append-to-body="true"
      :visible.sync="showCopyrightList"
      width="40%"
    >
      <div class="copyright-list">
        <template v-for="(item, index) in copyrightList">
          <div :key="index" class="copyright-item flex-c-b">
            <el-radio v-model="modelCopyrightId" :label="item.id">{{
              item.name
            }}</el-radio>
            <div
              @click="handleViewCopyright(item.value)"
              style="cursor: pointer"
            >
              {{ $t("modelPublish.ck") }}
            </div>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCopyrightList = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          class="confirm-copyright"
          @click="handleConfirmCopyrig"
          >{{ $t("common.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 模型版权声明列表 end -->

    <!-- 查看版权声明 -->
    <el-dialog
      :title="$t('modelPublish.bqsm')"
			:append-to-body="true"
      :modal-append-to-body="false"
      :visible.sync="showCopyrightDetial"
      width="40%"
    >
      <div
        class="copyright-detail"
        v-html="copyrightDetial"
        style="padding: 30px"
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          class="confirm-copyright"
          @click="showCopyrightDetial = false"
          >{{ $t("common.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看版权声明 end -->

    <!-- 绑定手机 S -->
    <el-dialog
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="bindMobileVisible"
      class="register-dialog"
      width="460px"
    >
      <div slot="title" class="dialog-title">
        <div class="f30 fwb mb10">{{ $t("header.bdsj") }}</div>
      </div>
      <div class="pd20">
        <div>
          <el-input
            class="mt20"
            type="text"
            v-model="bindMobileForm.phone"
            :placeholder="$t('login.qsrsjh')"
          >
            <!-- <template slot="prepend"><div style="margin-right: -20px">+86</div></template> -->
          </el-input>
          <el-input
            class="mt10"
            v-model="bindMobileForm.code"
            :placeholder="$t('login.qsryzm')"
          >
            <template slot="prepend">
              <div style="margin-right: -14px">
                <i class="el-icon-s-grid f20"></i>
              </div>
            </template>
            <template slot="append">
              <div
                v-if="!timerLoading && timerNum == 60"
                class="send-captcha"
                @click="getCaptcha('bindMobile')"
              >
                {{ $t("login.hqyzm") }}
              </div>
              <div v-else-if="timerLoading">{{ $t("login.fsz") }}</div>
              <div v-else-if="!timerLoading && timerNum != 0">
                {{ timerNum }}{{ $t("login.khq") }}
              </div>
            </template>
          </el-input>
        </div>
        <div class="button flex-c-b mt40">
          <div
            class="loginComfrim"
            style="width: 40%; border-radius: 10px"
            @click="bindMobileVisible = false"
          >
            {{ $t("common.cancel") }}
          </div>
          <div
            class="comfirm ml20"
            style="width: 60%; border-radius: 10px"
            @click="handleLoginByOauthBindMobile"
          >
            {{ $t("header.bd") }}
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 绑定手机 E -->
  </div>
</template>

<script>
import utils from "@/utils/utils";
import UploadImg from "@/components/UploadImg.vue";
import UploadFile from "@/components/UploadFile.vue";
import axios from "axios"; // 引入axios
import Cookies from "js-cookie";
import * as Base64 from "js-base64";
import { AES } from "crypto-js";
import api from '../api/api'
import { mapState, mapActions } from "vuex";
import CountryCode from './CountryCode';
export default {
  name: "headerView",
  components: {
    UploadImg,
    UploadFile,
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
      defaultAvatar: (state) => state.defaultAvatar,
      userInfo: (state) => state.userInfoModule.userInfo,
      searchText: (state) => state.search.searchText,
      loginStatus: (state) => state.loginStatus,
      carNum: (state) => state.carNum,
      // modelClass: (state) => state.dict.modelClass, // 模型分类
      showUploadModel: (state) => state.showUploadModel, // 显示上传模型弹窗
    }),

    // 格式化文件大小
    filesize() {
      return (val) => {
        return utils.formatFileSize(val);
      };
    },
  },
  watch: {
    $route(to, form) {
      // 处理打开多个标签页，在其中一个退出后回到另外的标签页操作时清除登录信息
      let token = Cookies.get("token");
      if (!token) {
        this.setToken(null);
        this.setSecretKey(null);
        this.setUserInfo(null);
      }

      // 离开工作台板块时关闭socket链接
      if (to.path.indexOf("workbenches") == -1) {
        this.initSocket(false);
      } else {
        if (!!this.token) {
          this.initSocket(true);
        }
      }
    },
    loginStatus(newV, oldV) {
      console.log("登录弹窗：", newV);
      this.loginVisible = newV;
    },

    showUploadModel(val) {
      if (val) {
        this.openUploadModel();
      }
    },

    uploadModelVisible(val) {
      if (!val) {
        this.setShowUploadModel(val);
      }
    },
  },
  data() {
    return {
      copyModelClass: [],
      select: 1, //1:支付宝，2：微信支付
      isPhoneRegist: true, // true 手机注册 false 邮箱注册
      isPhoneLogin: 1, // 1 验证码登录， 2 邮箱登录， 3 账号密码登录
      // 路由
      routes: [
        // 模型库
        { path: "/modelLib", name: this.$t("header.modelBase"), field: [] },
        // 模型专栏
        {
          path: "/modelColumn",
          name: this.$t("header.modelColumn"),
          field: ["/columnDetail"],
        },
        // 产品库
        {
          path: "/productLibrary",
          name: this.$t("header.productLibrary"),
          field: ["/productDetail", "/shop"],
        },
      ],
      registerVisible: false, //注册弹框
      registerInfo: {
        // 注册信息
        phone: undefined,
        code: undefined,
        email: undefined,
        passWord: undefined,
      },
      loginVisible: false, //登录弹框
      loginInfo: {
        // 登录信息
        phone: undefined,
        code: undefined,
        passWord: undefined,
      },
      isAutoLogin: false, //是否自动登录
      isVip: false, //是否是会员

      // 模型发布form表单
      modelPublishForm: {
        modelSource: 1, // 模型来源
        modelCopyrightId: 0, // 版权声明
        modelChargeStatu: 1, // 模型收费状态: zyy_model_charge 0-收费 1-免费
        modelPrice: "", // 章鱼币价格
        modelProof: [], // 模型证明
        modelName: "", // 模型名称
        modelClass: "", // 模型类别
        modelFiles: [], // 模型文件
        modelPrivacy: 0, // 模型隐私: zyy_model_privacy 0-公用 1-私用
        modelDisplay: [], // 模型展示图
        modelIntroduce: "", // 模型介绍
      },
      modelCopyrightId: 0, // 选择的版权声明id
      modelCopyrightName: "", // 选择的版权声明名称
      modelProofList: [], // 模型证明列表
      modelFilesList: [], // 模型文件列表
      isUploadModelFilesErr: false, // 上传模型文件报错，控制删除文件按钮显示
      modelDisplayList: [], // 模型图集/模型展示图

      lang: "en", //1：简体中文,2英文

			uploadModelVisible: false, //上传模型弹框
			isSubmitModel: false, // 是否是点击提交上传模型
			isCancelModel: false, // 是否是点击取消上传模型
      uploadModelInfo: {
        // 上传模型信息
        price: undefined, //价格
        name: undefined, //模型名称
        type: undefined, //模型类别
        memo: undefined, //描述
      },
      imageUrl: undefined,
      nextLogin: false, //下次自动登录
      agreeWith: false, //是否同意协议
      autoLogin: false, //30天自动登录
      registCodeText: "获取验证码",
      loginCodeText: "获取验证码",
      //扫码登录
      scanCodeVisible: false, //扫码弹窗
      scanCodeType: 1, //1移动端APP登录 2微信登录

      timer: undefined, // 计时器实例
      timerNum: 60, // 计时器倒计时
      timerLoading: false, // 计时器初始化中

      search: "", // 搜索文字
      qrCode: "", // 二维码登录的二维码
      isScanQrCode: false, // 是否扫码

      copyrightList: [], // 模型版权声明列表
      showCopyrightList: false, // 显示模型版权声明列表
      showCopyrightDetial: false, // 显示模型版权声明详情
      copyrightDetial: "", // 模型版权声明详情

      bindMobileVisible: false, // 绑定手机号可见性
      bindMobileForm: {
        phone: "",
        code: "",
        type: "",
        unionid: "",
      },
      searchSelect: 0,

      uploadFileParamData: {},
      ossUploadUrl: "",
      acceptFile: ".stl, .obj",

      FacebookLoading: false,
      GoogleLoading: false,
      loginGoogle: null,

			areaNum: CountryCode.map(item => ({...item, dh: item.dh.toLocaleLowerCase()})),
			areaNumActive: '+1'
    };
  },
async  mounted() {
  await  this.http(api.dictList, { dictType: "zyy_model_class" }, 'get').then(res => {
        if (res.code == 200) {
          // console.log('res.rows',res.rows);
          this.modelClass = res.rows
        }
      });
    this.copyModelClass = [...this.modelClass];
    console.log('111',this.copyModelClass);
    this.copyModelClass = this.copyModelClass.filter((obj) => {
      return obj.dictLabel !== "VIP";
    });
    console.log("modelClass", this.copyModelClass);
    this.lang = "en";
    if(this.lang === 'ja') {
      console.log('lis',document.querySelectorAll('.el-menu-item'));
      let lis = document.querySelectorAll('.el-menu-item')
      lis[1].style = 'margin-left: 20px;'
      lis[2].style = 'margin-left: 20px;'
    }
    this.nextLogin = localStorage.getItem("nextLogin") == "true" || false;
    // let _token = localStorage.getItem('token') || '';
    // let _secretKey = localStorage.getItem('secretKey') || '';

    localStorage.setItem("lang", this.lang);
    if (this.lang == "en" || this.lang == 'ja') {
      let gapiTimer = setInterval(() => {
        if (!!window.gapi) {
          clearInterval(gapiTimer);
          gapi.load("auth2", () => {
            // 加载谷歌API
            gapi.auth2.init();
          });
        }
      }, 1000);

      // gapi.load('auth2', () =>{ // 加载谷歌API
      //   gapi.auth2.init();
      // });
    }
    if (!this.token) {
      let _token = Cookies.get("token") || "";
      let _secretKey = Cookies.get("secretKey") || "";
      this.setToken(_token);
      this.setSecretKey(_secretKey);
    }

    if (!!this.token) this.getUserInfo();
    // this.getQrCode();
    //判断是否有
    this.setCarNum();

    let code = this.utils.getParam("code");
    let state = this.utils.getParam("state");
    if (!!code && state == "wechatLogin") {
      this.getAccessToken(code);
    }
    if (!!code && state == "wechatBind") {
      this.$router.push({
        path: "/user/setAccount",
        query: {
          code: code,
          bindThreeType: 1, // 1 微信，2 qq，3 微博
          state: state,
        },
      });
    }

    if (state == "qqLogin") {
      this.qqGetOpenId();
    }
    if (state == "qqBind") {
      this.$router.push({
        path: "/user/setAccount",
        query: {
          bindThreeType: 2, // 1 微信，2 qq，3 微博
          state: state,
        },
      });
    }

    if (!!code && state == "weiboLogin") {
      this.getWeiboAccessToken(code);
    }
    if (!!code && state == "weiboBind") {
      this.$router.push({
        path: "/user/setAccount",
        query: {
          code: code,
          bindThreeType: 3, // 1 微信，2 qq，3 微博
          state: state,
        },
      });
    }

    if (!!this.token) {
      this.getCopyrightList();
    }
  },
  methods: {
    ...mapActions({
      setToken: "setToken",
      setSecretKey: "setSecretKey",
      setUserInfo: "userInfoModule/setUserInfo",
      setSearchText: "search/setSearchText",
      setLoginStatus: "setLoginStatus",
      setCarNum: "setCarNum",
      initSocket: "webSocketState/initSocket", // 初始化 websocket
      setAgreement: "setAgreement",
      setShowUploadModel: "setShowUploadModel",
      deleteFiles: "deleteFiles",
    }),

    //跳转路由
    toModel(path) {
      if (!this.token && path !== "/") {
        this.setLoginStatus(true);
        return;
      }
      if (this.$route.path !== path)
        this.$router.push({
          path,
        });
    },
    // 没有账号？免费注册
    goRegist() {
      this.loginVisible = false;
      this.registerVisible = true;
    },
    // 已有账号？去登录
    goLogin() {
      this.loginVisible = true;
      this.registerVisible = false;
    },
    // 邮箱or手机注册
    setPhoneOrEmailRegist(val) {
      this.isPhoneRegist = val;
    },
    // 邮箱注册
    setPhoneOrEmailLogin(val) {
      this.loginInfo = {
        // 登录信息
        phone: undefined,
        code: undefined,
        passWord: undefined,
      };
      this.isPhoneLogin = val;
    },
    //跳转购物车
    toShoppingCart() {
      if (!this.token) {
        this.setLoginStatus(true);
        return;
      }
      if (this.$route.path !== "/shoppingCart") {
        this.$router.push({ path: "/shoppingCart" });
      } else {
        location.reload();
      }
    },
    // 设置语言
    setLanguage(type) {
      console.log(type);
      localStorage.setItem("lang", type);
      location.reload();
      return;
      this.$i18n.locale = type;
      this.lang = type;
    },

    // 上传证明
    handleModelProofSuccess(res, file) {
      this.modelProofList.push(res.data);
      this.modelPublishForm.modelProof = this.modelProofList.map(
        (item) => item["id"]
      );
    },
    // 删除证明
    delModelProofImg(index) {
      let delTargetImg = [this.modelProofList[index].path];
      let delTargetImgId = [this.modelProofList[index].id];
      this.deleteFiles({filePathArr: delTargetImg, fileIdArr: delTargetImgId});
      this.modelProofList.splice(index, 1);
      this.modelPublishForm.modelProof = this.modelProofList.map(
        (item) => item["id"]
			);
			this.$refs.modelProofRef.removeFiles(index);
    },

    // 模型文件上传前
    modelFileBeforeUpload(file) {
      let isLt2M = file.size / 1024 / 1024 < 500;
      let ext = file.name.substring(file.name.lastIndexOf("."));
      let isFileType = this.acceptFile.includes(ext);

      if (!isLt2M) {
        // this.$message.error(this.$t('modelPublish.file_tips01'));
        this.utils.reminderMsg(this.$t("modelPublish.file_tips01"), 1);
      } else if (!isFileType) {
        // this.$message.error(this.$t('modelPublish.file_type_err'));
        this.utils.reminderMsg(this.$t("modelPublish.file_type_err"), 1);
      } else {
        this.modelFilesList = this.modelFilesList.concat([
          {
            fileId: 0,
            pathThumb: "",
            fileName: file.name,
            modelFileProgress: 0,
            percent: 0,
            size: file.size,
            fileUid: file.uid,
          },
        ]);
      }
      return isLt2M && isFileType;
    },

    // 模型文件上传中
    modelFileUploadProgress(res, file, index) {
      this.modelFilesList.forEach((item) => {
        if (item.fileUid == file.uid) {
          item.modelFileProgress = res.loaded;

          let percent = (res.loaded / res.total) * 100 || 0;
          item.percent = percent;
        }
      });
    },

    // 上传模型文件成功
    handleModelFileSuccess(res, file) {
      // this.modelFilesList.forEach(item => {
      //   if (item.fileUid == file.uid) {
      //     item.fileId = res.data.id;
      //   }
      // });

      this.modelUpload(res.data, file);
    },

    // 记录oss上传成功后的文件信息
    modelUpload(url, file, baseFileId) {
      // let fileMd5 = this.$md5(this.uploadFileParamData.key);
      let fileMd5 = "--";
      let params = {
        path: url,
        md5: fileMd5.toString(),
        fileSize: file.size,
      };
      // const key = 'QISUI9WLNGZPKQCF';
      // const iv = 'SBSAI9W8NGYPKQCV';
      // const ciphertext = AES.encrypt(url, key, {iv: iv}).toString()
      // console.log('ciphertext>>>>>>>>', Base64.encode(ciphertext));
      // setTimeout(() => {
      //   const bytes = AES.decrypt('ucq9TCEvwP3+/c4dt220rVYJiG8c+AFKLr/VebBlem9CK9+imO5RisohH+76fHQ1ttyiCvg1tbjqMadssPH41g==', key, {iv: iv})
      //   const plaintext = bytes.toString(this.$CryptoJS.enc.Utf8)
      //   console.log('plaintext>>>>>>>>>>>>>>>>>', plaintext)
      // });
      if (!!baseFileId) params["baseFileId"] = baseFileId;
      this.http(this.api.modelUpload, params, "get").then((_res) => {
        if (_res.code == 200) {
          this.modelFilesList.forEach((item) => {
            if (item.fileUid == file.uid) {
              if (!baseFileId) item.fileId = _res.data;
              item.filePath = url;
            }
          });

					// 因提交时才上传文件，这里做所有文件上传完成后开始调用提交模型接口
					// let targetFiles = this.modelFilesList.filter(item => !!item.fileId);
					// if (targetFiles.length == this.modelFilesList.length) {
					// 	this.handleSubimtModel('submit');
					// }

          // if (!baseFileId) {
          //   this.uploadModelOptimize(url, _res.data, (res) => {
          //     let resp = res.data;
          //     if (resp.code == 200) {
          //       // this.modelUpload(resp.data.path, file, _res.data);
          //     } else {
          //       this.$message.error(res.msg);
          //     }
          //   });
          // }
        } else {
          this.$message.error(_res.msg);
        }
      });
    },

    // 上传模型文件失败
    triggerUploadError(res, fileIndex) {
      this.isUploadModelFilesErr = true;
    },

    // 删除模型文件
    delModelFile(index, item) {
      this.modelFilesList.splice(index, 1);
      this.modelPublishForm.modelFiles = this.modelFilesList.map((item) => ({'fileId': item['fileId'], 'pathThumb': item['pathThumb']}));
      this.isUploadModelFilesErr = false;
      let targetPaths = [item.filePath];
      let targetIds = [item.fileId];
      if (!!item.picPath) targetPaths.push(item.picPath);
      if (!!item.thumbPicId) targetIds.push(item.thumbPicId);
      this.deleteFiles({filePathArr: targetPaths, fileIdArr: targetIds});
    },

    // 上传模型文件缩略图
    handleModelFilesImgSuccess(res, item) {
      item["pathThumb"] = res.data.url;
      item["picPath"] = res.data.path;
      item["thumbPicId"] = res.data.id;
    },

    // 删除模型文件缩略图
    delModelFilesImg(index) {
      this.deleteFiles({filePathArr: [this.modelFilesList[index].picPath], fileIdArr: [this.modelFilesList[index].thumbPicId]});
      this.modelFilesList[index]["pathThumb"] = "";
      this.modelFilesList[index]["picPath"] = "";
      this.modelFilesList[index]["thumbPicId"] = "";
    },

    // 上传模型图集/模型展示图
    handleModelDisplayList(res, file) {
      this.modelDisplayList.push(res.data);
    },

    // 删除模型图集/模型展示图
    delModelDisplay(index) {
      let delTargetImg = [this.modelDisplayList[index].path];
      let delTargetImgId = [this.modelDisplayList[index].id];
      this.deleteFiles({filePathArr: delTargetImg, fileIdArr: delTargetImgId});
			this.modelDisplayList.splice(index, 1);
			this.$refs.modelDisplayRef.removeFiles(index);
    },

    // 提交
		handleSubimtModel(type) {
			const that = this;
			let pLanguage = "en";
			let modelPublishForm = JSON.parse(JSON.stringify(this.modelPublishForm));

			if (modelPublishForm.modelSource == 0) {
				// 请选择模型来源
				// this.$message.error(this.$t('modelPublish.qxzmxly'));
				this.utils.reminderMsg(this.$t("modelPublish.qxzmxly"), 1);
				return;
			}
			if (modelPublishForm.modelCopyrightId == 0) {
				// 请选择只是共享协议
				// this.$message.error(this.$t("modelPublish.xzgxxy"));
				this.utils.reminderMsg(this.$t("modelPublish.xzgxxy"), 1);
				return;
			}
			if (modelPublishForm.modelSource == 1 || modelPublishForm.modelSource == 3) {
				if (
					modelPublishForm.modelChargeStatu == 0 &&
					!modelPublishForm.modelPrice
				) {
					// 请输入章鱼币价格
					// this.$message.error(this.$t('modelPublish.srzybjg'));
					this.utils.reminderMsg(this.$t("modelPublish.srzybjg"), 1);
					return;
				}

				if (!this.modelProofList.length) {
					// 请上传模型证明
					// this.$message.error(this.$t('modelPublish.qscmxzm'));
					this.utils.reminderMsg(this.$t("modelPublish.qscmxzm"), 1);
					return;
				}
			}

			if (this.modelFilesList.length == 0) {
				// 请上传模型文件
				// this.$message.error(this.$t('modelPublish.qscmxwj'));
				this.utils.reminderMsg(this.$t("modelPublish.qscmxwj"), 1);
				return;
			}

			if (
				this.modelFilesList.filter((item) => !!item.fileId).length !=
				this.modelFilesList.length
			) {
				// 请上传模型文件
				// this.$message.error(this.$t('modelPublish.qscmxwj'));
				this.utils.reminderMsg(this.$t("modelPublish.qscmxwj"), 1);
				return;
			}

			let pathThumbLength = this.modelFilesList.filter(
				(item) => item.pathThumb
			).length;
			if (pathThumbLength != this.modelFilesList.length) {
				// 请上传模型缩略图
				// this.$message.error(this.$t('modelPublish.qscmxwjslt'));
				this.utils.reminderMsg(this.$t("modelPublish.qscmxwjslt"), 1);
				return;
			}
			if (!modelPublishForm.modelName) {
				// 请输入60个字以内的名称
				// this.$message.error(this.$t('modelPublish.mxmc_placeholder'));
				this.utils.reminderMsg(this.$t("modelPublish.mxmc_placeholder"), 1);
				return;
			}
			if (!modelPublishForm.modelClass) {
				// 请选择模型类别
				// this.$message.error(this.$t('modelPublish.mxlb_placeholder'));
				this.utils.reminderMsg(this.$t("modelPublish.mxlb_placeholder"), 1);
				return;
			}
			if (!this.modelDisplayList.length) {
				// 请上传图集
				// this.$message.error(this.$t('modelPublish.qsctj'));
				this.utils.reminderMsg(this.$t("modelPublish.qsctj"), 1);
				return;
			}
			let params = {
				...modelPublishForm,
				modelProof: this.modelProofList.map((item) => item["id"]),
				modelFiles: this.modelFilesList.map((item) => ({
					fileId: item["fileId"],
					pathThumb: item["pathThumb"],
					thumbPicId: item["thumbPicId"],
				})),
				modelDisplay: this.modelDisplayList.map((item) => item["id"]),
				category: pLanguage == "en" ? 1 : 0,
			};
			const loading = this.$loading({
				lock: true,
				text: this.$t("common.zztj"),
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.5)",
			});

			setTimeout(() => {
				this.http(this.api.addModel, params, "post").then((res) => {
					loading.close();
					if (res.code == 200) {
						// this.$message.success(this.$t('common.submit_success'));
						this.modelFilesList.forEach((item) => {
							if (!!item.filePath) {
								this.uploadModelOptimize(item.filePath, item.fileId, (res) => {
									let resp = res;
									if (resp.code == 200) {
										// this.modelUpload(resp.data.path, file, _res.data);
									} else {
										this.$message.error(res.msg);
									}
								});
							}
						});
						this.utils.reminderMsg(this.$t("common.submit_success"), 0);
						this.resetModelPublish();
						this.uploadModelVisible = false;
						this.modelCopyrightId = 0;
						this.modelCopyrightName = "";
						this.isSubmitModel = true;
						// location.reload();
					} else {
						this.$message.error(res.msg);
					}
				});
			}, 800);
    },

    // 重置模型发布表单
    resetModelPublish() {
      // 模型发布form表单
      this.modelPublishForm = {
        modelSource: 1, // 模型来源
        modelCopyrightId: 0, // 版权声明
        modelChargeStatu: 1, // 模型收费状态: zyy_model_charge 0-收费 1-免费
        modelPrice: "", // 章鱼币价格
        modelProof: [], // 模型证明
        modelName: "", // 模型名称
        modelClass: "", // 模型类别
        modelFiles: [], // 模型文件
        modelPrivacy: 0, // 模型隐私: zyy_model_privacy 0-公用 1-私用
        modelDisplay: [], // 模型展示图
        modelIntroduce: "", // 模型介绍
      };
      this.modelCopyrightId = 0; // 选择的版权声明id
      this.modelCopyrightName = ""; // 选择的版权声明名称
      this.modelProofList = []; // 模型证明列表
      this.modelFilesList = []; // 模型文件列表
      this.isUploadModelFilesErr = false; // 上传模型文件报错，控制删除文件按钮显示
      this.modelDisplayList = []; // 模型图集/模型展示图
    },

    //获取验证码
    getCaptcha(type) {
			if (type != "bindMobile") {
        if (this.isPhoneLogin == 1) {
          if (!this.loginInfo.phone) {
            // this.$message.error(this.$t("login.qsrsjh"));
            this.utils.reminderMsg(this.$t("login.qsrsjh"), 1);
            return;
          }
          if (this.lang == 'cn' && !this.utils.isMobile(this.loginInfo.phone)) {
            this.utils.reminderMsg(this.$t("login.qsrzqsjh02"), 1);
            return;
          }
        } else if (this.isPhoneLogin == 2) {
          if (!this.loginInfo.phone) {
            this.utils.reminderMsg(this.$t("login.qsryx"), 1);
            return;
          }
          if (!this.utils.isEmail(this.loginInfo.phone)) {
            // this.$message.error(this.$t("login.qsrzqsjh"));
            this.utils.reminderMsg(this.$t("login.qsrzqyx"), 1);
            return;
          }
        }
      } else {
        if (!this.bindMobileForm.phone) {
          // this.$message.error(this.$t("login.qsrsjh"));
          this.utils.reminderMsg(this.$t("login.qsrsjh"), 1);
          return;
        }
        if (!this.utils.isMobile(this.bindMobileForm.phone)) {
          // this.$message.error(this.$t("login.qsrzqsjh"));
          this.utils.reminderMsg(this.$t("login.qsrzqsjh02"), 1);
          return;
        }
      }

      let params = {
        mobile:
          type != "bindMobile"
            ? this.loginInfo.phone
            : this.bindMobileForm.phone,
        userType: 0, // 用户类型(0:前台用户 1:后台用户)
        captchaType: type != "bindMobile" ? 0 : 1, // 验证码类型(0:登录验证码，1:绑定账号验证码)
      };
      if (!!this.bindMobileForm.type)
				params["oauthType"] = this.bindMobileForm.type;
			if (this.lang != 'cn') {
				params.mobile = this.areaNumActive + params.mobile;
			}
      if (this.isPhoneLogin == 2)
        params = {
          toEmail: this.loginInfo.phone,
          type: 3, // 用户类型(1:绑定邮箱，2:解除绑定, 3: 邮箱登录 )
        };
      this.timerLoading = true;
      let aipPath = this.api.sendCaptcha;
      if (this.isPhoneLogin == 2) aipPath = this.api.sendMailLoginCaptcha;
      this.http(aipPath, params, "post").then((res) => {
        this.timerLoading = false;
        if (res.code == 200) {
          this.timerNum--;
          this.timer = setInterval(() => {
            this.timerNum--;
            if (this.timerNum <= 0) {
              clearInterval(this.timer);
              this.timerNum = 60;
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //扫码登录

    //打开扫码登录弹窗
    /**
     * type 1移动端 2微信
     */
    goScanCode(type) {
      this.scanCodeType = type;
      this.loginVisible = false; //关闭登录弹窗
      this.scanCodeVisible = true; //打开扫码登录弹窗
      if (type == 1) this.getQrCode();
      if (type == 2) {
        this.$nextTick(() => {
          this.initWxLogin();
        });
      }
    },

    // 点击登录回调
    handleLogin() {
      if (!this.loginInfo.phone && this.isPhoneLogin == 1) {
        // this.$message.error(this.$t("login.qsrsjh"));
        this.utils.reminderMsg(this.$t("login.qsrsjh"), 1);
        return;
      }
      if (!this.loginInfo.phone && this.isPhoneLogin == 2) {
        // this.$message.error(this.$t("login.qsrsjh"));
        this.utils.reminderMsg(this.$t("login.qsryx"), 1);
        return;
      }
      if (!this.loginInfo.phone && this.isPhoneLogin == 3) {
        this.utils.reminderMsg(this.$t("login.qsrsjhOryx"), 1);
        return;
      }

      if (!this.utils.isEmail(this.loginInfo.phone) && this.isPhoneLogin == 2) {
        this.utils.reminderMsg(this.$t("login.qsrzqyx"), 1);
        return;
      }

			if (
				this.lang == 'cn' &&
				!this.utils.isMobile(this.loginInfo.phone) &&
        !this.utils.isEmail(this.loginInfo.phone) &&
        this.isPhoneLogin == 3
      ) {
        // this.$message.error(this.$t("login.qsrzqsjh"));
        this.utils.reminderMsg(this.$t("login.qsrzqsjh"), 1);
        return;
      }
			if (
				this.lang != 'cn' &&
				this.loginInfo.phone.indexOf('@') > 0 &&
        !this.utils.isEmail(this.loginInfo.phone) &&
        this.isPhoneLogin == 3
      ) {
        // this.$message.error(this.$t("login.qsrzqsjh"));
        this.utils.reminderMsg(this.$t("login.qsrzqsjh"), 1);
        return;
      }
      if (
        !this.loginInfo.code &&
        (this.isPhoneLogin == 1 || this.isPhoneLogin == 2)
      ) {
        // this.$message.error(this.$t("login.qsryzm"));
        this.utils.reminderMsg(this.$t("login.qsryzm"), 1);
        return;
      }
      if (!this.loginInfo.passWord && this.isPhoneLogin == 3) {
        // this.$message.error(this.$t("login.qsrmm"));
        this.utils.reminderMsg(this.$t("login.qsrmm"), 1);
        return;
      }
      if (!this.agreeWith) {
        // this.$message.error(this.$t("login.tyysxy"));
        this.utils.reminderMsg(this.$t("login.tyysxy"), 1);
        return;
      }
      let params = {};
      let apiPath = "";
      if (this.isPhoneLogin == 1) {
        // 验证码登录
        params = {
          mobile: this.loginInfo.phone,
          captcha: this.loginInfo.code,
          userType: 0, // 用户类型(0:前台用户 1:后台用户)
				};
				if (this.lang != 'cn') {
					params.mobile = this.areaNumActive + params.mobile;
				}
        apiPath = this.api.loginByCaptcha;
      } else if (this.isPhoneLogin == 2) {
        // 邮箱验证码登录
        params = {
          email: this.loginInfo.phone,
          captcha: this.loginInfo.code,
          userType: 0, // 用户类型(0:前台用户 1:后台用户)
        };
        apiPath = this.api.loginByCaptcha;
      } else {
        // 账号密码登录
        params = {
          username: this.loginInfo.phone,
          password: this.loginInfo.passWord,
          userType: 0, // 用户类型(0:前台用户 1:后台用户)
        };
        apiPath = this.api.loginByUsername;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      (params["platform"] = 3), // 1 Android, 2 IOS, 3 PC
        this.http(apiPath, params).then((res) => {
          loading.close();
          if (res.code == 200) {
            this.setToken(`Bearer ${res.data.jwt}`);
            this.setSecretKey(res.data.secretKey);
            Cookies.set("token", `Bearer ${res.data.jwt}`);
            Cookies.set("secretKey", res.data.secretKey);

            this.loginVisible = false;
            this.getUserInfo();
            if (this.nextLogin) {
              localStorage.setItem("nextLogin", this.nextLogin);
              localStorage.setItem("token", `Bearer ${res.data.jwt}`);
              localStorage.setItem("secretKey", res.data.secretKey);
            } else {
              localStorage.removeItem("token");
              localStorage.removeItem("secretKey");
              localStorage.removeItem("nextLogin");
            }
            //刷新当前页
            location.reload();
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    // 获取用户信息
    getUserInfo() {
      let params = {};
      this.http(this.api.getUserInfo, params, "get", {
        Authorization: this.token,
      }).then((res) => {
        this.setUserInfo(res.data);
      });
    },

    loginClose() {
      console.log("loginClose>>>>>>>>>>");
      this.setLoginStatus(false);
    },
    // 点击用户头像
    handleCommand(command) {
      switch (command) {
        case "userInfo":
          this.$router.push({ path: "/userInfo" });
          break;
        case "logout":
          this.handleLogout();
          break;
      }
    },

    // 退出登录
    handleLogout() {
      var that = this;
      this.$confirm(this.$t("login.qdtcm"), this.$t("common.hint"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          that.http(that.api.logout, {}, "get").then((res) => {
            if (res.code == 200) {
              that.setToken(null);
              that.setSecretKey(null);
              that.setUserInfo(null);
              that.initSocket(false);
              Cookies.remove("token");
              Cookies.remove("secretKey");
              localStorage.removeItem("token");
              localStorage.removeItem("secretKey");
              localStorage.removeItem("nextLogin");
              location.href = "/";
            } else {
              that.setToken(null);
              that.setSecretKey(null);
              that.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },

    // 点击搜索
    handleSearch(type) {
      // if (!this.search) return;
      // this.setSearchText(this.search);
      // console.log(this.$route.path);
      // let  goodsList =  ['/productLibrary','/productLibrary/list','/productDetail','/shop'];
      // if(goodsList.indexOf(this.$route.path) == -1 && this.$route.path !='/'){
      //   this.$router.push({ name: "home", query: { } });
      // }
			if (type != 'enterSearch') return;

      // 搜索模型
      if (this.searchSelect == 0) {
        this.$router.push({
          path: "/modelLib",
          query: { keyword: this.search },
        });
      }
      // 搜索模型专栏
      if (this.searchSelect == 1) {
        this.$router.push({
          path: "/modelColumn",
          query: { keyword: this.search },
        });
      }
      // 搜索产品库
      if (this.searchSelect == 2) {
        this.$router.push({
          path: "/productLibrary/list",
          query: { keyword: this.search },
        });
      }
    },
    // 获取二维码
    getQrCode() {
      this.http(this.api.generateQrCode, {}, "get").then((res) => {
        if (res.code == 200) {
          this.qrCode = `data:image/png;base64,${res.data.QrCode}`;
          this.getPolling(res.data.uuid);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 轮询获取token
    getPolling(uuid) {
      let params = {
        uuid: uuid,
      };
      this.http(this.api.polling, params, "get").then((res) => {
        if (res.code == 200) {
          this.isScanQrCode = res.data.isScan;
          if (
            this.scanCodeVisible &&
            this.scanCodeType == 1 &&
            !res.data.token
          ) {
            setTimeout(() => {
              this.getPolling(uuid);
            }, 2000);
          } else if (!!res.data.token) {
            this.setToken(`Bearer ${res.data.token}`);
            this.setSecretKey(res.data.secretKey);
            Cookies.set("token", `Bearer ${res.data.token}`);
            Cookies.set("secretKey", res.data.secretKey);
            this.loginVisible = false;
            this.getUserInfo();

            if (this.autoLogin) {
              let _time = Date.now();
              let endTime = _time + 86400000 * 30;
              let timeFormat = this.utils.format(endTime, "yyyy-mm-dd");
              localStorage.setItem(
                "autoLoginTime",
                `${timeFormat}%Bearer ${res.data.token}`
              );
            }
            //刷新当前页
            location.href = "/";
          } else {
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //登录
    handleHeadreLogin() {
      this.setLoginStatus(true);
    },
    //点击上传模型
    openUploadModel() {
      if (!this.token) {
        this.setLoginStatus(true);
        return;
      }
      this.uploadModelVisible = true;
      this.getPolicy();
    },
    //打开开通会员弹窗
    openBuyMemberVisible() {
      if (!this.token) {
        this.setLoginStatus(true);
      } else {
        this.$router.push({ path: "/userBuyVip" });
      }
      // this.openBuyMemberVisible = true;
    },

    // 初始化微信登录
    initWxLogin() {
      var obj = new WxLogin({
        self_redirect: false,
        id: "wxLogin_container",
        appid: "wx4a26b9af08ddf836",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent("https://core.octopusworks.com"),
        // redirect_uri: encodeURIComponent("http://core.octopusworks.com/callbackqq/"),
        state: "wechatLogin",
        style: "",
        href: "https://core.octopusworks.com/css/threeWxLogin.css",
      });
    },

    // 获取微信登录的access_token
    getAccessToken(code) {
      let params = {
        code: code,
      };
      this.http(this.api.getWXAuthToken, params, "get").then((res) => {
        if (res.code == 200) {
          // 登录方式(1:QQ，2:微信，3:微博)
          if (!res.data) return;
          // let data = JSON.parse(res.data);
          // if (!!data.errcode) return;
          this.handleLoginByOauth(res.data, 2);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // qq登录
    openBindView() {
      QC.Login.showPopup({
        appId: "102055403",
        redirectURI: "http://core.octopusworks.com/callbackqq?state=qqLogin",
      });
    },

    qqGetOpenId() {
      const that = this;

      QC.Login.getMe(function (openId, accessToken) {
        console.log("qqGetOpenId>>openId>>>>>>>", openId);
        console.log("qqGetOpenId>>accessToken>>>>>>>", accessToken);
        let params = {
          code: accessToken,
        };
        that.http(that.api.getQQAuthToken, params, "get").then((res) => {
          if (res.code == 200) {
            // 登录方式(1:QQ，2:微信，3:微博)
            if (!res.data) return;
            // let data = JSON.parse(res.data);
            // if (!!data.errcode) return;
            that.handleLoginByOauth(res.data, 1);
          } else {
            that.$message.error(res.msg);
          }
        });
      });
    },

    // 微博登录
    openWeiBoView() {
      let redirect_uri = encodeURIComponent("http://core.octopusworks.com");
      window.open(
        `https://api.weibo.com/oauth2/authorize?client_id=3741842978&response_type=code&redirect_uri=${redirect_uri}&state=weiboLogin`
      );
    },

    getWeiboAccessToken(code) {
      let params = {
        code: code,
        url: "http://core.octopusworks.com",
      };
      this.http(this.api.getWBAuthToken, params, "get").then((res) => {
        if (res.code == 200) {
          // 登录方式(1:QQ，2:微信，3:微博)
          if (!res.data) return;
          // let data = JSON.parse(res.data);
          this.handleLoginByOauth(res.data, 3);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 三方登录
    handleLoginByOauth(unionid, type) {
      let params = {
        // code: unionid,
        type: type, // 登录方式(1:QQ，2:微信，3:微博, 4 Google, 5 Facebook)
        platform: 3, // 1 Android, 2 IOS, 3 PC
        uuid: unionid, // 用户uuid
      };
      this.http(this.api.loginByOauth, params, "post").then((res) => {
        if (res.code == 200) {
          this.setToken(`Bearer ${res.data.jwt}`);
          this.setSecretKey(res.data.secretKey);
          Cookies.set("token", `Bearer ${res.data.jwt}`);
          Cookies.set("secretKey", res.data.secretKey);
          this.loginVisible = false;
          this.getUserInfo();
          //刷新当前页
          // location.reload();
          location.href = "/";
        } else if (res.code == 500) {
          // 没有绑定手机号执行代码
          this.bindMobileForm.type = type;
          this.loginVisible = false;
          // this.bindMobileForm.unionid = unionid;
          this.bindMobileForm.uuid = unionid;
          this.bindMobileVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 获取模型版权声明
    getCopyrightList() {
      let lang = "en";
      let language = "en_US"; // 国际化 “en_US” 英文 “ “或”CN”为中文
      if (lang == "en") language = "en_US";

      let params = {
        // lang: language,
      };
      this.http(this.api.getCopyrightList, params, "get").then((res) => {
        if (res.code == 200) {
          this.copyrightList = res.rows;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 选择版权声明
    handleConfirmCopyrig() {
      this.modelPublishForm.modelCopyrightId = this.modelCopyrightId;
      this.copyrightList.forEach((item) => {
        if (item.id == this.modelCopyrightId)
          this.modelCopyrightName = item.name;
      });
      this.showCopyrightList = false;
    },
    // 显示版权声明详情
    handleViewCopyright(val) {
      this.showCopyrightDetial = true;
      this.copyrightDetial = val;
    },

    //跳转链接
    toTapUrl(path, param) {
      ///防相同路由跳转
      this.setLoginStatus(false);
      if (this.$route.path !== path) {
        this.$router.push({
          path: path,
          query: param,
        });
      } else {
        if (path == "/agreement") {
          this.setAgreement(param.type);
        }
      }
    },

    handleLoginByOauthBindMobile() {
      if (!this.bindMobileForm.phone) {
        // this.$message.error(this.$t("login.qsrsjh"));
        this.utils.reminderMsg(this.$t("login.qsrsjh"), 1);
        return;
      }
      if (!this.utils.isMobile(this.bindMobileForm.phone)) {
        // this.$message.error(this.$t("login.qsrzqsjh"));
        this.utils.reminderMsg(this.$t("login.qsrzqsjh02"), 1);
        return;
      }
      if (!this.bindMobileForm.code) {
        // this.$message.error(this.$t("login.qsryzm"));
        this.utils.reminderMsg(this.$t("login.qsryzm"), 1);
        return;
      }
      let params = {
        mobile: this.bindMobileForm.phone,
        type: this.bindMobileForm.type,
        // 'code': this.bindMobileForm.unionid,
        uuid: this.bindMobileForm.uuid,
        captcha: this.bindMobileForm.code,
        captchaType: 1, // 验证码类型(1:绑定手机号验证码，2:三方注册验证码，3:修改密码验证码，4:解绑手机号验证码，5:解绑邮箱验证码，6:绑定邮箱验证码)
        platform: 3, // 1 Android, 2 IOS, 3 PC
      };
      this.http(this.api.loginByOauthBindMobile, params, "post").then((res) => {
        if (res.code == 200) {
          this.setToken(`Bearer ${res.data.jwt}`);
          this.setSecretKey(res.data.secretKey);
          Cookies.set("token", `Bearer ${res.data.jwt}`);
          Cookies.set("secretKey", res.data.secretKey);
          //刷新当前页
          location.href = location.origin;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleZiDongLogin() {
      this.nextLogin = !this.nextLogin;
    },
    handleWangJi() {
      this.$router.push({ path: "/changePassword" });
      this.setLoginStatus(false);
    },
    selectMenu() {
      this.search = "";
    },

    // 点击30天内登录
    handleAutoLogin30() {
      this.autoLogin = !this.autoLogin;
    },

    getPolicy() {
      this.http(this.api.getPolicy, {}, "get").then((res) => {
        this.uploadFileParamData = {
          key: res.dir,
          policy: res.policy,
          OSSAccessKeyId: res.accessid,
          success_action_status: 200,
          signature: res.signature,
        };
      });
    },

    // 自定义上传模型文件
		uploadModelFile(option) {
			const key = this.uploadFileParamData.key + option.file.name;
			let params = { ...this.uploadFileParamData, key: key, file: option.file };
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });

      this.http(
        this.api.checkRemainStorageSpace,
        { fileSize: option.file.size },
        "get"
      ).then((res) => {
        if (res.code == 200) {
          axios({
            url: "https://pppa.oss-cn-shenzhen.aliyuncs.com",
            method: "post",
            data: formData,
            headers: { Authorization: this.token },
            onUploadProgress: (res) => {
              option.onProgress(res, option.file);
            },
          })
            .then((res) => {
              option.onSuccess({ code: 200, data: params.key });
            })
            .catch(this.triggerUploadError);
        } else {
          // this.$message.error(this.$t('modelPublish.cckjbz'));
          this.utils.reminderMsg(this.$t("modelPublish.cckjbz"), 1);
          let modelFilesList = this.modelFilesList.map((v) => v.uid);
          let modelFilesIndex = modelFilesList.indexOf(option.file.uid);
          this.modelFilesList.splice(modelFilesIndex, 1);
        }
      });
    },

    // 输入章鱼币
    inputZybCallback(value) {
      let numStr = /^[0-9]*$/;
      if (numStr.test(value)) {
        if (value >= 0 && value < 10000) {
          this.modelPublishForm.modelPrice = value;
        } else {
          if (value < 0) this.modelPublishForm.modelPrice = "";
          this.modelPublishForm.modelPrice = value.substring(0, 4);
        }
      } else {
        this.modelPublishForm.modelPrice = value.replace(/[^0-9]/g, "");
      }
    },

    // 优化上传的模型
    // uploadModelOptimize(url, baseFileId, successCallback) {
    //   axios({
    //     url: 'https://model-optimize.octopusworks.com/api/model/optimize',
    //     method: 'post',
    //     data: {
    //       // ossFilePath: Base64.encode(url),
    //       ossFilePath: url,
    //       baseFileId: baseFileId
    //     },
    //     headers: {
    //       Authorization: this.token,
    //     }
    //   }).then(res => {
    //     successCallback(res);
    //   }).catch(error => {
    //     console.error(error);
    //   });
    // },

    // 上传模型弹窗关闭时删除已上传的文件
		uploadModelClose(type) {
			const that = this;
			if (that.isSubmitModel) {
				that.uploadModelCloseCallback();
			} else {
				if (this.isCancelModel) return;
				if (type == 'cancel') {
					this.isCancelModel = true;
				}
				that.$confirm(that.$t("modelPublish.uploadModelCloseMsg"), {
					confirmButtonText: that.$t("common.confirm"),
					cancelButtonText: that.$t("common.cancel"),
					type: "warning",
				}).then(() => {
					that.uploadModelCloseCallback();
				}).catch(() => {
					this.isCancelModel = false;
				});
			}
		},

		/**
		 * 上传模型弹窗关闭后的数据处理回调
		 */
		uploadModelCloseCallback() {
			this.uploadModelVisible = false;
			this.isSubmitModel = false;

			let targetPaths = [];
			let targetId = [];
			this.modelFilesList.forEach((item) => {
				if (!!item.filePath) targetPaths.push(item.filePath);
				if (!!item.fileId) targetId.push(item.fileId);
				if (!!item.picPath) targetPaths.push(item.picPath);
				if (!!item.thumbPicId) targetId.push(item.thumbPicId);
			});
			this.modelDisplayList.forEach((item) => {
				targetPaths.push(item.path);
				targetId.push(item.id);
			});
			this.modelProofList.forEach((item) => {
				targetPaths.push(item.path);
				targetId.push(item.id);
			});

			if (!!targetPaths.length) this.deleteFiles({filePathArr: targetPaths, fileIdArr: targetId});
			this.resetModelPublish();
			this.$refs.modelDisplayRef.$refs.uploadRef.clearFiles();
			this.$refs.modelProofRef.$refs.uploadRef.clearFiles();
		},

    // Feckbock登录授权
    onFBSignSuccess(user) {
      const that = this;
      // 请求后端接口，对登录信息进行校验
      console.log("Feckbock登录授权", user);
      FB.getLoginStatus(function (response) {
        console.log("Feckbock登录状态检查", response);
        // 登录状态 - 已登录
        if (response.status === "connected") {
          console.log("Feckbock登录状态", response);
          that.FBLogin(response.authResponse.accessToken);
        } else {
          // 登录状态 - 未登录
          FB.login(
            function (res) {
              console.log("Feckbock登录信息", res);
              if (res.status != "unknown")
                that.FBLogin(res.authResponse.accessToken);
              // 获取用户资料
            },

            // 授权的各种权限
            //[facebook权限参考文档](https://developers.facebook.com/docs/permissions/reference)
            { scope: "public_profile,email" }
          );
        }
      });
    },
    onFBSignError(error) {
      console.log(error);
    },
    FBLogin(code) {
      let params = {
        code: code,
        type: 2, // 1 app, 2 pc,
      };
      this.http(this.api.getFacebookAuthAppToken, params, "get").then((res) => {
        if (res.code == 200) {
          this.handleLoginByOauth(res.data, 5);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    openLoginDialog() {
      // 加载Facebook sdk和初始化
      if ( this.lang == "en"  || this.lang == "ja"  &&  !window.FB ) {
        this.FacebookLoading = true;
        window.fbAsyncInit = function () {
          FB.init({
            appId: "855596819536330", // 填入自己 app 的 id
            cookie: true,
            xfbml: true,
            version: "v2.7", // 目前版本
          });
        };
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");

        let FB_yes = setInterval(() => {
          this.FacebookLoading = !window.FB;
          if (!this.FacebookLoading) {
            clearInterval(FB_yes);
          }
        }, 1000);
      }

      if (this.lang == "en" ||  this.lang == "ja" && !window.google) {
        const that = this;
        this.GoogleLoading = true;
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://accounts.google.com/gsi/client";
          js.onload = () => {
            that.loginGoogle = google.accounts.oauth2.initCodeClient({
              client_id:
                "484565833534-vuffak8q2s462nsl7kfeaunpoklrs593.apps.googleusercontent.com",
              scope:
                "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
              ux_mode: "popup",
              callback: (response) => {
                console.log("Google 授权成功>>>>>>>>>", response);
                let params = {
                  code: response.code,
                  type: 2, // 1 app, 2 pc,
                };
                that
                  .http(that.api.getGoogleAccessToken, params, "get")
                  .then((res) => {
                    if (res.code == 200) {
                      // let data = JSON.parse(res.data);
                      that.handleLoginByOauth(res.data, 4);
                    } else {
                      that.$message.error(res.msg);
                    }
                  });
              },
            });
          };
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "google-jssdk");
        let G_yes = setInterval(() => {
          this.GoogleLoading = !window.google;
          if (!this.GoogleLoading) {
            clearInterval(G_yes);
          }
        }, 1000);
      }
    },

		/**
		 * 上传模型文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
		 */
		handleFileChange(e) {
			console.log('>>>>>>>>', e);
			if (e.status == 'ready') {
				this.modelFileBeforeUpload(e.raw);
			}
		}
  },
  created() {
    var params = this.$route.query;
  },
  filters: {
    filterVip(classNames) {
      console.log("classNames", classNames);
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and(max-width: 1820px) {
  .search-view-bg {
    display: none;
  }
}
@media screen and(max-width: 1420px) {
  .menuNav {
    display: none;
  }
}
@media screen and(max-width: 1050px) {
  .workbenches,
  .file-upload,
  .purchaseCar {
    display: none !important;
  }
}
@media screen and(max-width: 750px) {
  .right {
    display: none !important;
  }
}
.header-view {
  padding: 0;
}
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 60px;
  background-color: #eee;
  .logo {
    width: auto;
    height: auto;
    a {
      display: block;
      width: 100px;
      height: 26px;
      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.nav {
  width: 100%;
  padding: 0 60px;
  display: flex;
  justify-content: space-between;
  height: 70px;
  .logo {
    width: 113px;
    height: 40px;
  }
  .right {
    width: auto;
    display: flex;
    align-items: center;
    color: #000;
    .file-upload {
      display: flex;
      align-items: center;
      margin: 0 20px;
      cursor: pointer;
    }
    .workbenches {
      display: flex;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;
    }
    .purchaseCar {
      cursor: pointer;
    }
    .vip {
      // width: 60px;
      height: 30px;
      padding: 5px;
      line-height: 20px;
      cursor: pointer;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin: 0 23px;
      border-radius: 4px;
      background: linear-gradient(79deg, #e80000 2.08%, #ff800b 94%);
    }

    .vip2 {
      display: flex;
      align-items: center;
      margin: 0 22px;
      cursor: pointer;
      // margin-top: -4px;
      .time {
        margin: 0 6px;
        color: #d71518;
        font-size: 14px;
      }
      .renew {
        width: 56px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-radius: 13px;
        color: #fff;
        font-size: 14px;
        background: linear-gradient(79deg, #e80000 2.08%, #ff800b 94%);
      }
    }

    .login {
      // width: 34px;
      height: 34px;
      padding: 7px 3px;
      line-height: 20px;
      text-align: center;
      border-radius: 20px;
      background: #999;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  // .menuNav 
   /*  li {
      margin-left: 20px;
    }
    li:first-child {
      margin-left: 0;
    } */
  
}

.divider {
  margin: 0 !important;
}
.out-time {
  font-size: 14px;
  font-weight: bold;
  color: #d71518;
}
.active {
  width: 166px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #ff0000;
  border-radius: 1px;
  position: relative;
}
.default {
  width: 166px;
  height: 60px;
  background: #ffffff;
  border-radius: 1px;
  position: relative;
}
.active-img {
  width: 24px;
  height: 24px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.renew {
  min-width: 50px;
  height: 24px;
  background: linear-gradient(90deg, #ff373a 0%, #ff8b60 100%);
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #fffefe;
  padding: 0 5px;
}
.avatar-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
}

.send-captcha,
.user-box {
  cursor: pointer;
}

.qr-code {
  width: 230px;
  height: 230px;
  position: relative;
  margin: 30px auto;

  .el-image {
    width: 100%;
    height: 100%;
  }

  .qr-code-shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    color: #333;

    .success-img {
      background: #fff;
      border-radius: 50%;
    }
  }
}

#wxLogin_container {
  width: 230px;
  height: 300px;
  margin: 15px auto 0;

  /deep/ iframe {
    width: 100%;
    height: 100%;
  }
}

.model-source {
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #ffebeb;
    border-color: #ffebeb;
    box-shadow: #ffebeb -1px 0px 0px 0px;
    color: #c32d30;
  }
  /deep/ .el-radio-button__inner:hover {
    color: #c32d30;
  }
}

.model-proof-list {
  flex-wrap: wrap;

  .model-proof-item {
    width: 130px;
    height: 130px;
    background: #ffffff;
    border: 1px solid #d6d6d6;
    border-radius: 2px;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;

    .el-image {
      width: 100%;
      height: 100%;
    }

    .del-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 9;
      text-align: right;
      background: rgba(0, 0, 0, 0.3);
      padding: 2px 5px;

      .del-icon {
        font-size: 20px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}

.mode-file-list {
  .mode-file-item {
    align-items: stretch;

    .file-thumb {
      width: 80px;
      height: 80px;
      position: relative;

      .el-image {
        width: 100%;
        height: 100%;
      }

      .del-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9;
        text-align: right;
        background: rgba(0, 0, 0, 0.3);
        padding: 2px 5px;

        .del-icon {
          font-size: 16px;
          color: #fff;
          cursor: pointer;
        }
      }
    }

    .mode-file-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: start;

      .file-name {
        font-size: 20px;
        color: #333;
      }

      .del-icon {
        font-size: 20px;
        cursor: pointer;
      }

      .model-file-size {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
  }

  .mode-file-item + .mode-file-item {
    margin-top: 20px;
  }
}

.upload-box {
  width: 100%;
  height: 100%;

  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }
}
/deep/ .UploadFile {
  width: 100%;
  height: 100%;

  .el-upload {
    width: 100%;
    height: 100%;
  }
}

.copyright-list {
  padding: 10px 30px;

  .copyright-item {
    padding: 15px 0;
    border-bottom: 1px solid #ededed;
  }
}

.confirm-copyright {
  background: #c32d30;
  border-color: #c32d30;

  &.el-button--primary:focus,
  &.el-button--primary:hover {
    background: #ce4c4e !important;
    border-color: #ce4c4e !important;
    color: #fff;
  }
}

.search-view-bg {
  .el-select {
    width: 90px;

    &.en {
      width: 125px;
    }

    /deep/ .el-input__inner {
      padding-left: 0;
      text-align: center;
    }
  }

  .input::placeholder {
    color: #ccc;
  }
}

// .header-view {
  // z-index: 9999;
// }

.el-divider--horizontal {
  margin: 15px 0;
}

.check {
  width: 12px;
  height: 12px;
  font-size: 12px;
}

.ther-login .el-divider__text {
  font-size: 16px;
}
</style>
